// Davomat — `xsib-attendance` servisi bilan kontrakt.
// Qurilma: Hikvision DS-K1T343MFWX (yuzni tanish terminali, ISAPI + Digest).
// Manba: `backend/migration/.../V202608110100__attendance_init.sql`
// (`attendance.device` jadvali va undagi izohlar).
//
//   GET    /api/attendance/devices?q&status&active&page&size
//                                                 → {rows, total, page, size}
//   GET    /api/attendance/devices/{id}           → AttendanceDevice
//   POST   /api/attendance/devices                → AttendanceDevice
//   PUT    /api/attendance/devices/{id}           → {device, result} ⚠️ D4
//   DELETE /api/attendance/devices/{id}           → OperationResult
//   POST   /api/attendance/devices/{id}/probe     → DeviceProbeResult
//   POST   /api/attendance/devices/{id}/open-door → OperationResult
//   POST   /api/attendance/devices/{id}/webhook   → OperationResult
//
//   GET    /api/attendance/employees?q&active&page&size
//                                                 → {rows, total, page, size}
//   GET    /api/attendance/employees/{id}         → AttendanceEmployee
//   POST   /api/attendance/employees              → AttendanceEmployee
//   PUT    /api/attendance/employees/{id}         → AttendanceEmployee
//   DELETE /api/attendance/employees/{id}         → OperationResult
//   GET    /api/attendance/employees/{id}/photo   → image/jpeg (BINAR)
//   POST   /api/attendance/employees/{id}/photo   → OperationResult (multipart)
//   POST   /api/attendance/employees/{id}/sync    → OperationResult
//
//   GET    /api/attendance/events?from&to&deviceId&employeeNo&result&page&size
//                                                 → {rows, total, page, size}
//   GET    /api/attendance/events/{id}/picture    → image/jpeg (BINAR)
//
//   GET    /api/attendance/report?date=YYYY-MM-DD        → DailyReport
//   GET    /api/attendance/report/monthly?month&employeeId → MonthlyReport
//   GET    /api/attendance/report/last-seen?withinDays   → LastSeenReport
//   GET    /api/attendance/report/present                → PresentReport
//   GET    /api/attendance/report/export?date|month&employeeId&deviceId&format=csv
//                                                        → text/csv (BINAR)
//
// ⚠️ SAHIFA MAYDONI `rows` — BUTUN PANELDA BITTA. `nas`, `sites`,
// `subscribers`, `ledger`, `session` va boshqalar ham `rows` o'qiydi.
//
// ⚠️ 2026-08-14 GACHA BU YERDA `items` EDI va shu izohda "farq bor,
// lekin shunday" deb yozib qo'yilgandi. QA auditi o'lchadi: 22 ta
// sahifalangan endpointdan 17 tasi `rows`, 5 tasi `items` — ya'ni
// tafovut ongli qaror emas, nusxaning tarqalishi edi. Backend
// (`DevicePage`/`EmployeePage`/`EventPage`) va panel BIRGA `rows` ga
// o'tkazildi; ular ajralib qolsa zod HAR javobni rad etadi va sahifa
// "ma'lumot yo'q" bo'lib ko'rinadi (aynan shu holat
// `features/session/sessionApi.ts` da o'lchangan).
//
// ⚠️ Panelning O'Z ichki tipi `PageResult<T>` esa `{items, total}`
// bo'lib QOLADI (`shared/ui/table/DataTable.tsx`) — u simdagi shakl
// emas, jadval komponentining shartnomasi va butun panel bo'ylab bir
// xil. Shuning uchun bu fayldagi `return { items: parsed.rows... }`
// qatorlari TO'G'RI, tuzatilmasin.
//
// ⚠️⚠️ YO'L PREFIKSI `/api/attendance/...` — SERVISNING CONTEXT-PATH'I
// (`/attendance`) BUNGA QO'SHILMAYDI. Bu ikki boshqa narsa: context-path
// servisning O'ZIDA, tashqi yo'l esa gateway marshrutida. `/attendance/api/...`
// yoki `/api/attendance/attendance/...` deb yozish MAVJUD BO'LMAGAN manzil
// beradi.
//
// Bu loyihada aynan shu xato ikki marta qilingan va u JIMGINA noto'g'ri
// javob bo'lib ko'ringan:
//   · `catalogApi.ts` — `@RequestMapping` dagi yo'l to'liq yo'l deb o'qilgan;
//     natijada 404 emas, TANASIZ 401 kelardi (xavfsizlik sozlamasi tufayli)
//     va panelda "sessiya tugadi" bo'lib ko'rinardi
//   · `priceApi.ts` — `/api/catalog/plans` o'rniga `/api/plans`; sahifa 404
//     oldi va bu panelda "narx qo'yilmagan" bo'lib ko'rinardi
// Ikkalasida ham sabab kod ichida emas, YO'LDA edi va uni topish uzoq davom
// etdi. Shuning uchun yo'llar yuqorida to'liq holda yozilgan.
//
// ⚠️ PAROL HECH QACHON O'QILMAYDI. Bazada u shifrlangan holda
// (`device.password_enc`, hash EMAS — Digest auth parolning o'zini talab
// qiladi), API'da esa umuman qaytmaydi. Quyidagi sxemada bunday maydon
// YO'Q va bo'lmasligi ham kerak: zod noma'lum maydonni tashlab yuboradi,
// ya'ni u tasodifan ekranga chiqib ketmaydi.
//
// ⚠️ Backend `jackson.default-property-inclusion: non_null` bilan ishlaydi:
// null maydonlar javobda UMUMAN BO'LMAYDI (`null` bo'lib ham kelmaydi).
// Shuning uchun ixtiyoriy maydonlar `.nullish()` — faqat `.nullable()`
// bo'lsa zod maydon YETISHMAYDI deb butun javobni rad etardi.

import { z } from 'zod'
import { api } from '@/shared/api/client'
import { operationResultSchema, type OperationResult } from '@/shared/api/operationResult'
import { instantSchema, uuidSchema } from '@/shared/api/schemas'
import { downloadBlob } from '@/shared/lib/download'
import type { PageResult } from '@/shared/ui/table/DataTable'
import type { TableState } from '@/shared/ui/table/tableState'

/**
 * Qurilma holati — `device_status_valid` cheklovidagi TO'RT qiymatning aynan o'zi.
 *
 * ⚠️ `AUTH_FAILED` `UNREACHABLE` DAN ATAYLAB AJRATILGAN va uni birlashtirish
 * taklifi rad etilgan. Farqi operator uchun hal qiluvchi:
 *
 *   `UNREACHABLE` — qurilma umuman javob bermayapti. Qidiriladigan joy:
 *                   tarmoq, quvvat, kabel, manzil
 *   `AUTH_FAILED` — qurilma TIRIK va javob beryapti, lekin foydalanuvchi
 *                   nomi yoki parol mos emas. Qidiriladigan joy: shu
 *                   yerdagi forma yoki qurilma sozlamasi
 *
 * Ikkinchisini "o'chiq" deb ko'rsatish operatorni butunlay boshqa
 * yo'nalishda — serverxonaga, kabelga — qidirishga majbur qilardi.
 *
 * Amaliy oqibati ham bor: Hikvision bir necha muvaffaqiyatsiz urinishdan
 * keyin manzilni ~30 daqiqaga QULFLAYDI. Ya'ni noto'g'ri parol bilan
 * qayta-qayta urinish o'zimizni o'zimiz qulflashga olib keladi — va buni
 * "javob yo'q" deb o'qigan odam aynan shunday qiladi.
 *
 * ⚠️ Ro'yxat `z.enum` bilan QOTIRILGAN, `z.string()` emas: backend yangi
 * holat qo'shsa panel uni jimgina "noma'lum" qilib chizmasin, zod xatosi
 * bilan darhol ko'rinsin (`nasApi.nasHealthStateSchema` bilan bir xil qoida).
 */
export const DEVICE_STATUSES = ['ONLINE', 'AUTH_FAILED', 'UNREACHABLE', 'UNKNOWN'] as const
export type DeviceStatus = (typeof DEVICE_STATUSES)[number]

/**
 * Soat farqi shundan katta bo'lsa — OGOHLANTIRISH (soniya).
 *
 * ⚠️ NEGA UMUMAN KERAK. 2026-08-11 da haqiqiy qurilmada o'lchangan:
 * terminal ekranda Toshkent vaqtini ko'rsatib turgan (18:51), lekin ISAPI
 * javobida uni `+08:00` (Shanghai) deb belgilagan. Ya'ni har bir hodisa
 * bazaga 3 SOATGA SURILGAN holda tushardi. Buni hech kim sezmasdi:
 * qurilma oldida turgan odam ekranda to'g'ri vaqtni ko'radi, hisobot esa
 * jimgina noto'g'ri chiqadi — va xato faqat oylik hisobot bilan haqiqat
 * solishtirilganda topilardi.
 *
 * 60 soniya — NTP siz ishlaydigan qurilmaning tabiiy siljishi bilan
 * haqiqiy nosozlik orasidagi chegara. Undan kichik qilish har kuni
 * yolg'on ogohlantirish berardi va belgi o'qilmay qo'yardi.
 *
 * ⚠️ Qiymat BACKENDDAGI bilan bir xil bo'lishi SHART:
 * `AttendanceDevice.hasSignificantClockSkew()` ham aynan 60 dan
 * foydalanadi va solishtiruv `>=`. Ikkisi ajralib ketsa panel bilan
 * server bir xil qurilma haqida qarama-qarshi xulosa berardi — ya'ni
 * ogohlantirish serverda bor, ekranda yo'q.
 */
export const CLOCK_SKEW_WARN_SECONDS = 60

/**
 * Terminal QAYSI YO'NALISHNI qayd etadi — `device_direction_valid`
 * cheklovidagi UCH qiymatning aynan o'zi.
 *
 * ⚠️⚠️ UCHTA, IKKITA EMAS — va `BOTH` "sozlanmagan" degani EMAS.
 *
 *   `IN`   — kirish nuqtasi: bu terminaldan o'tish "ishga keldi" degani
 *   `OUT`  — chiqish nuqtasi: "ishdan ketdi"
 *   `BOTH` — yo'nalish AJRATILMAYDI (bitta eshikda bitta terminal),
 *            ya'ni yo'nalish MA'LUM EMAS
 *
 * Bitta eshikda bitta terminal turishi — istisno emas, ODATIY hol: odam
 * undan kirishda ham, chiqishda ham o'tadi. Bunday qurilmani `IN` deb
 * belgilash o'lchov emas, YOLG'ON bo'lardi: hisobot barcha chiqishlarni
 * kelish deb yozardi va hech kim binodan chiqmagandek ko'rinardi.
 *
 * ⚠️ Qurilma yo'nalishni O'ZI AYTMAYDI. 2026-08-11 da haqiqiy
 * DS-K1T343MFWX da o'lchangan `minor` kodlarining (75, 76, 38, 21, 22)
 * birortasi ham "kirdi"/"chiqdi" demaydi. Ya'ni bu terminal QAYERGA
 * o'rnatilgani haqidagi operator bilimi.
 *
 * ⚠️ `z.enum` QOTIRILGAN (`DEVICE_STATUSES` bilan bir xil qoida): server
 * to'rtinchi qiymat qo'shsa panel uni jimgina "noma'lum" qilib
 * chizmasin.
 */
export const DEVICE_DIRECTIONS = ['IN', 'OUT', 'BOTH'] as const
export type DeviceDirection = (typeof DEVICE_DIRECTIONS)[number]

/**
 * Server QURILMAGA QANDAY YETADI — `device_connection_valid` cheklovidagi
 * ikki qiymatning aynan o'zi.
 *
 *   `DIRECT_ISAPI`  — filialda VPN bor, server qurilmani IP orqali ko'radi.
 *                     Manzil = `ipAddress:port`, hisob = `username`/parol.
 *   `ISUP_GATEWAY`  — filialda VPN YO'Q. Qurilmaning O'ZI internetdan Hik
 *                     Device Gateway'ga ulanadi, biz esa unga gateway
 *                     orqali boramiz. Manzil = gateway'dagi `isupDeviceId`.
 *
 * ⚠️⚠️ IKKALASI BIR VAQTDA ISHLAYDI — bu "eskisidan yangisiga o'tish"
 * emas. Bitta tashkilotda VPN'li filial ham, VPN'siz filial ham bo'ladi va
 * ular bir ro'yxatda turadi. Shuning uchun rejim QURILMANING sozlamasi,
 * global sozlama emas.
 *
 * ⚠️ MAYDONLAR BIR-BIRINI INKOR QILADI va buni BAZA majburlaydi (CHECK):
 *   DIRECT_ISAPI → `ipAddress`, `port`, `username`, parol MAJBURIY;
 *                  `isupDeviceId` BO'SH
 *   ISUP_GATEWAY → `isupDeviceId` va `isupKey` MAJBURIY; qolgan to'rttasi BO'SH
 *
 * Ya'ni "ko'zdan yashirish" yetarli emas: yashirilgan maydon so'rovda
 * qolib ketsa, server CHECK cheklovi bilan yiqiladi va xabar baza
 * darajasidagi tushunarsiz matn bo'lib qaytadi. Payloadni `buildConnectionPayload`
 * quradi — u faqat tanlangan rejimning maydonlarini qaytaradi.
 *
 * ⚠️ `z.enum` QOTIRILGAN (`DEVICE_STATUSES`, `DEVICE_DIRECTIONS` bilan bir
 * xil qoida): server uchinchi qiymat qo'shsa panel uni jimgina birinchisi
 * deb chizmasin.
 */
export const DEVICE_CONNECTION_TYPES = ['DIRECT_ISAPI', 'ISUP_GATEWAY'] as const
export type DeviceConnectionType = (typeof DEVICE_CONNECTION_TYPES)[number]

/**
 * Qurilma o'zi haqida aytgani — probe paytida yangilanadi (`device_info`).
 * Manba: `shared/devicegw/model/DeviceInfo.java`.
 *
 * Diagnostika uchun: "qaysi proshivkada ishlamadi" degan savolga javob.
 *
 * ⚠️ HAMMA MAYDON `nullish`. Bazada bu ustun `JSONB` va uni serverga
 * qurilmaning O'ZI to'ldiradi: eski proshivka `firmwareVersion` ni
 * qaytarmasligi, boshqa model esa `macAddress` ni umuman bermasligi
 * mumkin. Bittasini majburiy qilish bunday qurilmada BUTUN ro'yxatni
 * zod xatosi bilan yiqitardi — panel esa bu maydonlarsiz ham to'liq
 * ishlashi kerak.
 */
const deviceInfoSchema = z.object({
  model: z.string().nullish(),
  serialNumber: z.string().nullish(),
  firmwareVersion: z.string().nullish(),
  macAddress: z.string().nullish(),
  deviceName: z.string().nullish(),
})

/*
  ⚠️ `tenantId` va `eventWatermark` SXEMADA ATAYLAB YO'Q, garchi server
  ularni qaytarsa ham (`AttendanceDevice.java` rekordida bor). Zod noma'lum
  maydonni tashlab yuboradi, ya'ni ular panelga umuman kirmaydi:
    · `tenantId` — javob allaqachon FAQAT o'z tashkilotining qurilmalarini
      o'z ichiga oladi (servis qatlamidagi `WHERE tenant_id = :tenantId`),
      ya'ni bu maydon panelda hech qanday qarorga ta'sir qilmaydi va uni
      ekranga chiqarish tashkilot identifikatorini bekorga oshkor qilardi
    · `eventWatermark` — fon jarayonining ICHKI holati ("eventlar qayergacha
      tortilgan"). Uni operatorga ko'rsatish uni sozlanadigan qiymatdek
      ko'rsatardi, holbuki u faqat servis tomonidan yoziladi.
*/
const deviceSchema = z.object({
  id: uuidSchema,
  name: z.string(),
  /** Operator beradigan barqaror belgi (`kirish-1`), qurilma seriyasi EMAS */
  deviceId: z.string(),
  /**
   * ⚠️ `.nullish()` — server bu maydonni BERMASLIGI mumkin va bu ikki
   * xil holat: (a) eski javob (maydon hali qo'shilmagan), (b) yangi javob,
   * lekin qurilma `ISUP_GATEWAY` — o'shanda ustun `NULL` va Jackson
   * (`non_null`) uni javobga UMUMAN qo'ymaydi.
   *
   * Majburiy qoldirish BUTUN RO'YXATNI yiqitardi: bitta gateway qurilmasi
   * tufayli zod sahifani rad etar va operator "qurilma yo'q" degan yolg'on
   * xulosaga kelardi (`sessionApi.ts` da aynan shu holat o'lchangan).
   */
  ipAddress: z.string().nullish(),
  port: z.number().nullish(),
  username: z.string().nullish(),
  /**
   * ⚠️ `.nullish()` — eski javobda maydon YO'Q. Panelda u `DIRECT_ISAPI`
   * ga tushadi va bu YOLG'ON EMAS: gateway rejimi yo'q serverda barcha
   * qurilma haqiqatan to'g'ridan-to'g'ri ulanadi.
   */
  connectionType: z.enum(DEVICE_CONNECTION_TYPES).nullish(),
  /**
   * Qurilmaning O'ZIDA sozlangan ISUP raqami (`EhomeID`) — operator
   * kiritadi va u qurilma sozlamasidan ko'chiriladi.
   *
   * ⚠️ `gatewayDevIndex` BILAN CHALKASHTIRMANG — ular boshqa-boshqa narsa
   * va bu farq butun oqimning o'zagi:
   *
   *   `isupDeviceId`    — QURILMADA sozlangan, operator KIRITADI
   *   `gatewayDevIndex` — GATEWAY yaratadi, server ro'yxatdan
   *                       o'tkazgandan keyin QAYTARADI
   *
   * `DIRECT_ISAPI` da har doim `null`.
   */
  isupDeviceId: z.string().nullish(),
  /**
   * Gateway BERGAN qurilma identifikatori (`devIndex`).
   *
   * ⚠️⚠️ BUNI GATEWAY O'ZI YARATADI va qurilma unga ro'yxatdan
   * o'tkazilganda javobda qaytaradi (ISUP hujjati A.26: «globally unique
   * device ID, returned when adding successfully»). Ya'ni bu qiymat
   * dunyoda hech kimda — na operatorda, na qurilmada — ro'yxatdan
   * o'tishdan OLDIN mavjud emas.
   *
   * ⚠️ SHUNING UCHUN FORMADA UNI KIRITISH MAYDONI YO'Q va bo'lmasligi
   * ham kerak. Egasining talabi: administratorlar gateway konsoliga
   * kirmaydi — qurilmani gateway'ga BACKEND ro'yxatdan o'tkazadi.
   * Bu yerga kiritish maydoni qo'yish operatordan u hech qayerdan
   * ololmaydigan qiymatni so'rash bo'lardi.
   *
   * ⚠️ `null` — XATO EMAS, NORMAL o'tkinchi holat: qurilma hali
   * gateway'da ro'yxatdan o'tmagan. Shuning uchun panelda u bo'sh katak
   * emas, tushunarli matn bilan ko'rsatiladi (`lastSeenNever` bilan bir
   * xil qoida: bo'sh katak "ma'lumot yuklanmadi" bo'lib o'qilardi).
   */
  gatewayDevIndex: z.string().nullish(),
  /** ⚠️ QURILMANING zonasi, tenantniki emas — yuqoridagi izoh */
  timeZone: z.string(),
  fdId: z.string(),
  doorNo: z.number(),
  /**
   * ⚠️ `.nullish()` EMAS, MAJBURIY. Ustun `NOT NULL DEFAULT 'BOTH'`,
   * ya'ni server uni har doim beradi. Ixtiyoriy qilib qo'yish maydon
   * yo'qolgan kuni uni jimgina `BOTH` ga tushirardi — hisobot esa
   * yo'nalishli o'rnatmada boshqa (yolg'on) son ko'rsatardi.
   */
  direction: z.enum(DEVICE_DIRECTIONS),
  status: z.enum(DEVICE_STATUSES),
  /**
   * KETMA-KET muvaffaqiyatsizliklar. "O'lik" xulosasi bitta urinishdan
   * keyin chiqarilmaydi (`platform.nas_health` bilan bir xil sabab:
   * soxta ogohlantirish ogohlantirishga ishonchni yo'qotadi).
   *
   * Serverda `int` (`NOT NULL DEFAULT 0`), lekin sxema baribir `nullish`:
   * panel bazadagi cheklovga emas, JAVOBGA ishonadi (`nasApi.type` bilan
   * bir xil qoida).
   */
  consecutiveFailures: z.number().nullish(),
  lastError: z.string().nullish(),
  lastProbeAt: instantSchema.nullish(),
  /** ⚠️ Oxirgi MUVAFFAQIYATLI javob — "qachondan beri jim" faqat shundan chiqadi */
  lastSeenAt: instantSchema.nullish(),
  /** Musbat = qurilma soati oldinda. `null` = hali o'lchanmagan */
  clockSkewSeconds: z.number().nullish(),
  deviceInfo: deviceInfoSchema.nullish(),
  /**
   * ⚠️ QURILMA BIZGA QANDAY KELADI — `ipAddress` ning TESKARISI va u
   * bilan HECH QANDAY bog'liq emas.
   *
   *   server  → qurilma :  ipAddress:port
   *   qurilma → server  :  webhookHost:webhookPort
   *
   * `null` = global sozlama ishlatiladi
   * (`xsib.attendance.webhook.callback-host`). 2026-08-11 da bu farq
   * amalda xatoga olib keldi: operator qurilmaning O'Z LAN manzilini
   * kiritdi, server esa unga ko'prik orqali borardi — natijada qurilma
   * `UNREACHABLE` bo'lib qoldi. Bu «operator adashdi» emas: forma
   * maydonida farq tushuntirilmagan edi.
   */
  webhookHost: z.string().nullish(),
  webhookPort: z.number().nullish(),
  siteId: uuidSchema.nullish(),
  active: z.boolean(),
  createdAt: instantSchema.nullish(),
  updatedAt: instantSchema.nullish(),
})

export interface DeviceInfo {
  model: string | null
  serialNumber: string | null
  firmwareVersion: string | null
  macAddress: string | null
  deviceName: string | null
}

export interface AttendanceDevice {
  id: string
  name: string
  deviceId: string
  /**
   * ⚠️ `DIRECT_ISAPI` da to'ldirilgan, `ISUP_GATEWAY` da `null`. Uchala
   * maydon ham (`ipAddress`, `port`, `username`) bir vaqtda bo'sh bo'ladi —
   * gateway rejimida server qurilmaga IP orqali umuman bormaydi.
   */
  ipAddress: string | null
  port: number | null
  username: string | null
  /**
   * ⚠️ HECH QACHON `null` EMAS, garchi sxemada `.nullish()` bo'lsa ham:
   * maydon kelmasa `DIRECT_ISAPI` ga tushadi. Bu YOLG'ON EMAS — gateway
   * rejimi qo'shilishidan oldingi har bir qurilma haqiqatan
   * to'g'ridan-to'g'ri ulanadi. `null` qoldirish esa panelning HAR
   * joyida "rejim noma'lum" degan uchinchi holatni yaratardi va u hech
   * qanday qarorga xizmat qilmasdi.
   */
  connectionType: DeviceConnectionType
  /** Qurilmada sozlangan ISUP raqami (`EhomeID`). `DIRECT_ISAPI` da `null` */
  isupDeviceId: string | null
  /**
   * ⚠️ Gateway BERGAN identifikator. Forma yubormaydi, server ro'yxatdan
   * o'tkazgandan keyin oladi. `null` = hali ro'yxatdan o'tmagan (sxemadagi izoh)
   */
  gatewayDevIndex: string | null
  /*
    ⚠️⚠️ `isupKey` BU YERDA ATAYLAB YO'Q — `password` bilan AYNAN bir xil
    qaror va bir xil sabab (fayl sarlavhasidagi «PAROL HECH QACHON
    O'QILMAYDI» bo'limi). Kalit gateway'ga ulanish siri: bazada shifrlangan
    holda turadi, API'da umuman qaytmaydi va sxemada bunday maydon yo'q —
    ya'ni zod uni tashlab yuboradi va u tasodifan ham ekranga chiqmaydi.
  */
  timeZone: string
  fdId: string
  doorNo: number
  /** ⚠️ `BOTH` = yo'nalish MA'LUM EMAS, "sozlanmagan" emas (sxemadagi izoh) */
  direction: DeviceDirection
  status: DeviceStatus
  consecutiveFailures: number | null
  lastError: string | null
  lastProbeAt: string | null
  lastSeenAt: string | null
  clockSkewSeconds: number | null
  deviceInfo: DeviceInfo | null
  /** ⚠️ Qurilma BIZGA qanday keladi — `ipAddress` ning teskarisi (sxemadagi izoh) */
  webhookHost: string | null
  webhookPort: number | null
  siteId: string | null
  active: boolean
  createdAt: string | null
  updatedAt: string | null
}

function toDeviceInfo(raw: z.infer<typeof deviceInfoSchema> | null | undefined): DeviceInfo | null {
  if (!raw) return null
  return {
    model: raw.model ?? null,
    serialNumber: raw.serialNumber ?? null,
    firmwareVersion: raw.firmwareVersion ?? null,
    macAddress: raw.macAddress ?? null,
    deviceName: raw.deviceName ?? null,
  }
}

function toDevice(raw: z.infer<typeof deviceSchema>): AttendanceDevice {
  return {
    id: raw.id,
    name: raw.name,
    deviceId: raw.deviceId,
    ipAddress: raw.ipAddress ?? null,
    port: raw.port ?? null,
    username: raw.username ?? null,
    // ⚠️ `?? 'DIRECT_ISAPI'` — maydon YO'Q bo'lsa (eski server) qurilma
    // to'g'ridan-to'g'ri ulanadi. Sabab interfeys izohida.
    connectionType: raw.connectionType ?? 'DIRECT_ISAPI',
    isupDeviceId: raw.isupDeviceId ?? null,
    gatewayDevIndex: raw.gatewayDevIndex ?? null,
    timeZone: raw.timeZone,
    fdId: raw.fdId,
    doorNo: raw.doorNo,
    direction: raw.direction,
    status: raw.status,
    consecutiveFailures: raw.consecutiveFailures ?? null,
    lastError: raw.lastError ?? null,
    lastProbeAt: raw.lastProbeAt ?? null,
    lastSeenAt: raw.lastSeenAt ?? null,
    clockSkewSeconds: raw.clockSkewSeconds ?? null,
    deviceInfo: toDeviceInfo(raw.deviceInfo),
    webhookHost: raw.webhookHost ?? null,
    webhookPort: raw.webhookPort ?? null,
    siteId: raw.siteId ?? null,
    active: raw.active,
    createdAt: raw.createdAt ?? null,
    updatedAt: raw.updatedAt ?? null,
  }
}

/**
 * Javobda `password` bormi — bo'lsa BU NOSOZLIK, jimgina o'tkazilmaydi.
 *
 * Zod uni baribir tashlab yuboradi (sxemada bunday maydon yo'q), ya'ni
 * ekranga chiqmaydi. Lekin parolning TARMOQDAN O'TAYOTGANI o'z-o'zicha
 * muammo: u brauzer tarmoq panelida, keshda va log'da qoladi. Konsolga
 * aniq yozamiz — sinovchi buni ko'radi va backendga xabar qiladi
 * (`nasApi.assertNoSecret` bilan bir xil andoza va bir xil sabab).
 */
function assertNoPassword(body: unknown): void {
  // Bitta yozuv ham, sahifa ham shu funksiyaga keladi — ikkalasi ham
  // tekshirilishi kerak, aks holda tekshiruv `GET /{id}` da ishlab,
  // ro'yxatda jimgina o'tib ketardi.
  const rows: unknown[] =
    Array.isArray(body) ? body
    : typeof body === 'object' && body !== null && 'rows' in body && Array.isArray(body.rows)
      ? body.rows
      : [body]
  for (const row of rows) {
    if (typeof row !== 'object' || row === null) continue
    // ⚠️ `isupKey` ham SHU RO'YXATDA. U gateway'ga ulanish siri va
    // ro'yxat javobida kelmasligi kerak: kalit «Ulash ma'lumotlari»
    // oynasi ochilganda ALOHIDA so'rov bilan olinadi va backend o'sha
    // so'rovni audit qiladi. Ro'yxatda kelsa audit izi ham yo'qolardi —
    // ya'ni sirni kim ko'rgani hech qayerda qolmasdi.
    const leak = ['password', 'passwordEnc', 'isupKey', 'isupKeyEnc'].find((field) => field in row)
    if (leak) {
      console.error(
        `[xsib] XAVFSIZLIK: /api/attendance/devices javobida \`${leak}\` maydoni bor. ` +
          "Panel uni ko'rsatmaydi, lekin backend uni umuman qaytarmasligi kerak.",
      )
      return
    }
  }
}

/**
 * Sahifa javobi — `DevicePage.java`.
 *
 * ⚠️ `total` BOR (`hasNext` emas), ya'ni `pageResult.syntheticTotal`
 * KERAK EMAS va jadval haqiqiy sonni ko'rsatadi (`nasApi` bilan bir xil
 * holat, `ledger`/`audit` dan farqli).
 */
/**
 * Bitta qurilma javobini o'qiydi — sxema + panel shakliga o'girish.
 *
 * ⚠️ Alohida eksport qilingani ATAYLAB (`turnoverApi.parseTurnoverReport`
 * bilan bir xil andoza): shu funksiya orqali "eski server javobi" xulqi
 * sinovda TARMOQSIZ tekshiriladi. Maydonsiz javob `DIRECT_ISAPI` ga
 * tushishi — nusxalangan mantiq emas, HAQIQIY kod ustidagi o'lchov
 * bo'lishi kerak, aks holda sinov sxema o'zgargan kuni yashil qolardi.
 */
export function parseDevice(raw: unknown): AttendanceDevice {
  return toDevice(deviceSchema.parse(raw))
}

const devicePageSchema = z.object({
  rows: z.array(deviceSchema),
  total: z.number(),
  page: z.number(),
  size: z.number(),
})

/**
 * Qurilmalar ro'yxati — `DataTable` kutgan shaklda.
 *
 * ⚠️ SAHIFALASH VA QIDIRUV SERVERDA (`DeviceQuery`: `search`, `status`,
 * `siteId`, `active`, `page`, `size`). Mijoz tomonida filtrlash YECHIM
 * EMAS: u faqat JORIY sahifani ko'rardi va operator "bunday qurilma yo'q"
 * degan yolg'on xulosaga kelardi.
 *
 * ⚠️ Backend sahifani 0 dan sanaydi, `TableState.page` esa 1 dan
 * (foydalanuvchi ko'radigan raqam) — panel bo'ylab bir xil andoza
 * (`nasApi.fetchNasPage`, `equipmentApi.fetchEquipmentPage`).
 *
 * ⚠️ SARALASH SERVERDA YO'Q, shuning uchun ustunlarda `sorter`
 * QO'YILMAGAN: qo'yilsa u faqat joriy sahifani saralab, "eng yomon holat
 * yuqorida" degan yolg'on va'da berardi.
 */
export async function fetchDevicePage(
  state: TableState,
  signal: AbortSignal,
): Promise<PageResult<AttendanceDevice>> {
  const search = state.search.trim()
  const response = await api.get<unknown>('/api/attendance/devices', {
    signal,
    // Bo'sh qidiruv UMUMAN yuborilmaydi (`undefined`), bo'sh satr
    // sifatida emas — so'rov URL'i ham, kesh ham toza qoladi.
    params: { q: search === '' ? undefined : search, page: state.page - 1, size: state.pageSize },
  })
  assertNoPassword(response.data)
  const parsed = devicePageSchema.parse(response.data)
  return { items: parsed.rows.map(toDevice), total: parsed.total }
}

export async function fetchDevice(id: string): Promise<AttendanceDevice> {
  const response = await api.get<unknown>(`/api/attendance/devices/${id}`)
  assertNoPassword(response.data)
  return parseDevice(response.data)
}

/**
 * Ulanish maydonlari — REJIMGA QARAB bittasi to'ldiriladi, ikkinchisi
 * so'rovda UMUMAN BO'LMAYDI.
 *
 * ⚠️ Hamma maydon `?` bilan, garchi ularning har biri o'z rejimida
 * MAJBURIY bo'lsa ham. TypeScript "yo u, yo bu" ni shartnomada ifodalay
 * olardi (diskriminatsiyalangan birlashma), lekin u holda `DeviceUpdate`
 * dagi `Omit`/`extends` zanjiri ikkiga bo'linardi. Majburiylik shu sababli
 * BITTA joyda — `buildConnectionPayload` da — va u yagona quruvchi.
 * Payloadni qo'lda yig'ish TAQIQLANADI: yashirilgan maydon so'rovda qolib
 * ketsa server `device_connection_valid` CHECK cheklovi bilan yiqiladi va
 * xabar baza darajasidagi tushunarsiz matn bo'lib qaytadi.
 */
export interface DeviceConnectionFields {
  connectionType: DeviceConnectionType
  ipAddress?: string
  port?: number
  username?: string
  password?: string
  isupDeviceId?: string
  /**
   * ISUP kaliti (`EhomeKey`) — gateway'ga ro'yxatdan o'tkazish uchun SIR.
   *
   * ⚠️ `ehomeV5` protokolida MAJBURIY (ISUP hujjati A.25), ya'ni usiz
   * backend gateway'ga chala so'rov yuborardi va u yiqilardi. Ko'pi bilan
   * 32 belgi.
   *
   * ⚠️ `password` bilan bir xil qoida: javobda HECH QACHON qaytmaydi va
   * tahrirlashda bo'sh qoldirilsa YUBORILMAYDI ("tegilmasin").
   */
  isupKey?: string
}

/**
 * Yaratish — `DeviceDraft.java` ning aynan o'zi.
 *
 * ⚠️ `password` TIP DARAJASIDA IXTIYORIY BO'LIB QOLDI (ilgari majburiy
 * edi): `ISUP_GATEWAY` rejimida parol UMUMAN yo'q — server qurilmaga
 * gateway orqali boradi va ISAPI hisobini so'ramaydi. `DIRECT_ISAPI` da
 * u baribir majburiy va buni forma tekshiruvi bilan
 * `buildConnectionPayload` majburlaydi.
 *
 * ⚠️ `gatewayDevIndex` BU YERDA YO'Q va bo'lmaydi ham: uni server
 * gateway'dan o'zi topadi. Uni yuborish operator biladigan qiymatdek
 * ko'rsatardi, holbuki u gateway'ning ichki kaliti.
 *
 * ⚠️ `active` MAYDONI YO'Q — bu server qarori, panel taxmini emas: yangi
 * qurilma har doim faol bo'lib yaratiladi (`device.active` ustuni
 * `DEFAULT TRUE`). "Nofaol holda yaratish" degan stsenariy amalda yo'q —
 * qurilma qo'shilishining sababi uni ishga tushirish.
 */
export interface DeviceDraft extends DeviceConnectionFields {
  name: string
  deviceId: string
  timeZone: string
  fdId: string
  doorNo: number
  /**
   * ⚠️ Terminal QAYSI YO'NALISHNI qayd etadi (`DEVICE_DIRECTIONS`).
   *
   * Yaratishda IXTIYORIY: server berilmasa `BOTH` qo'yadi
   * (`DeviceDraft` kompakt konstruktori). Forma esa uni baribir har
   * doim yuboradi — "standart bor" degan bilim ikki joyda turmasin.
   */
  direction?: DeviceDirection
  siteId?: string | null
  /**
   * ⚠️ QURILMA BIZGA QANDAY KELADI — `ipAddress` ning teskarisi.
   *
   * Bo'sh (`null`) qoldirilsa global sozlama ishlatiladi
   * (`xsib.attendance.webhook.callback-host`). Per-qurilma qiymat
   * globaldan USTUN turadi: NAT ortidagi qurilma serverni bir manzilda,
   * o'sha tarmoqdagi ikkinchisi butunlay boshqasida ko'radi — bitta
   * global sozlama YETMAYDI.
   *
   * ⚠️ Host bilan port BIRGA yuboriladi yoki ikkalasi ham `null`:
   * bazada `device_webhook_pair` cheklovi bor va yarim sozlama
   * jimgina global qiymatga tushib ketardi.
   */
  webhookHost?: string | null
  webhookPort?: number | null
}

/**
 * Tahrirlash — `DeviceUpdate.java` ning aynan o'zi.
 *
 * ⚠️ `deviceId` BU YERDA YO'Q va bu ataylab: belgi qurilmaning o'zligi,
 * uni tahrirlash "boshqa qurilma" degani bo'lardi va hodisalar tarixi
 * noto'g'ri qurilmaga bog'lanib qolardi (`equipmentApi.EquipmentUpdate`
 * dagi `serialNumber` bilan aynan bir xil qaror va bir xil sabab).
 *
 * ⚠️ `password` IXTIYORIY va bu shaklning eng muhim qismi. Server parolni
 * hech qachon qaytarmaydi, ya'ni forma uni oldindan to'ldira OLMAYDI.
 * Shuning uchun qoida: maydon bo'sh qoldirilsa — parol O'ZGARMAYDI
 * (backendda `DeviceUpdate.changesPassword()` aynan shuni tekshiradi).
 *
 * Muqobil variant (parolni har tahrirda majburiy qilish) yomonroq bo'lardi:
 * operator qurilma nomini tuzatish uchun ham parolni qayerdandir topib,
 * qaytadan terishga majbur bo'lardi — va bir marta xato tersa, keyingi
 * probe'gacha hech narsa bilinmasdi, keyin esa Hikvision manzilni
 * ~30 daqiqaga qulflab qo'yardi.
 *
 * `undefined` — "tegilmasin". `null` yuborilmaydi: u "parolni tozala"
 * degan ma'noga ega bo'lardi, bunday amal esa umuman mavjud emas.
 *
 * `active` esa AYNAN BU YERDA: qurilmani vaqtincha so'rovdan chiqarish
 * tahrirlash amali (ta'mirdagi terminal), yaratish amali emas.
 */
export interface DeviceUpdate extends Omit<DeviceDraft, 'deviceId' | 'direction'> {
  active: boolean
  /**
   * ⚠️⚠️ TAHRIRLASHDA MAJBURIY (`DeviceDraft` da esa ixtiyoriy) — va
   * bu asimmetriya SERVER TALABI, panel injiqligi emas:
   * `DeviceUpdate.direction` da `@NotNull` turadi va maydonsiz so'rov
   * **400** oladi.
   *
   * Sabab 2026-08-12 dagi `active` minasi: qisman PUT so'rovida tushib
   * qolgan maydonni Jackson standart qiymat bilan to'ldirardi va
   * so'rov MUVAFFAQIYATLI tugardi. Bu yerda u operator qo'ygan
   * `IN`/`OUT` ni jimgina `BOTH` ga qaytarardi — hisobot esa ovozsiz
   * ravishda "tartib bo'yicha" rejimiga tushardi.
   */
  direction: DeviceDirection
}

/** Formadagi xom qiymatlar — bo'sh maydon `''`, tozalangan maydon `null` */
export interface ConnectionFormInput {
  connectionType: DeviceConnectionType
  ipAddress?: string | null
  port?: number | null
  username?: string | null
  password?: string | null
  isupDeviceId?: string | null
  isupKey?: string | null
}

/**
 * Ulanish maydonlarini REJIMGA QARAB yig'adi — so'rov tanasining yagona
 * quruvchisi.
 *
 * <h2>⚠️ NEGA BU ALOHIDA FUNKSIYA</h2>
 * Formada maydonni ko'zdan yashirish YETARLI EMAS. antd formasi qiymatni
 * o'z do'konida saqlab qolishi mumkin (maydon oldin ko'rsatilib, keyin
 * yashirilgan bo'lsa), va o'sha qiymat so'rovga qo'shilib ketardi. Server
 * tomonda uni `device_connection_valid` CHECK cheklovi ushlaydi — lekin
 * xato BAZA darajasidan qaytadi va operator ekranda o'zi tushunmaydigan
 * matn ko'radi. Ya'ni nuqson ko'rinadi, lekin HECH NARSA aytmaydi.
 *
 * Shuning uchun payload yagona joyda quriladi va u faqat TANLANGAN
 * rejimning maydonlarini qaytaradi. Boshqa rejimning maydoni natijada
 * `undefined` bo'lib ham qolmaydi — kalitning O'ZI yo'q.
 *
 * <h2>⚠️ BO'SH QIYMAT KALIT QO'SHMAYDI</h2>
 * `''` va `null` — "kiritilmagan". Ularni bo'sh satr bo'lib yuborish
 * `NOT NULL` ustunga bo'sh qiymat yozardi va CHECK "to'ldirilgan" deb
 * o'qirdi: qurilma manzilsiz, lekin "to'g'ri sozlangan" bo'lib qolardi.
 *
 * ⚠️ Parol `ISUP_GATEWAY` da UMUMAN qaytarilmaydi — operator uni rejim
 * almashishidan oldin kiritgan bo'lsa ham. Gateway rejimida ISAPI hisobi
 * ishlatilmaydi va uni yuborish parolni bekorga tarmoqdan o'tkazardi.
 *
 * ⚠️ `gatewayDevIndex` bu yerda YO'Q va qo'shilmasin: uni server topadi.
 */
export function buildConnectionPayload(values: ConnectionFormInput): DeviceConnectionFields {
  const text = (value: string | null | undefined): string | undefined => {
    const trimmed = (value ?? '').trim()
    return trimmed === '' ? undefined : trimmed
  }

  if (values.connectionType === 'ISUP_GATEWAY') {
    const isupDeviceId = text(values.isupDeviceId)
    const isupKey = text(values.isupKey)
    return {
      connectionType: 'ISUP_GATEWAY',
      ...(isupDeviceId === undefined ? {} : { isupDeviceId }),
      // ⚠️ Bo'sh kalit YUBORILMAYDI — tahrirlashda bu "tegilmasin"
      // degani (`password` bilan aynan bir xil naqsh). Bo'sh satr
      // yuborilsa u mavjud sirni O'CHIRIB yuborardi va qurilma
      // gateway'dan jimgina tushib qolardi.
      ...(isupKey === undefined ? {} : { isupKey }),
    }
  }

  const ipAddress = text(values.ipAddress)
  const username = text(values.username)
  const password = text(values.password)
  return {
    connectionType: 'DIRECT_ISAPI',
    ...(ipAddress === undefined ? {} : { ipAddress }),
    // ⚠️ `typeof === 'number'` — `0` ham son, lekin `null`/`undefined`
    // kalit qo'shmaydi. `?? undefined` yozilsa kalit BOR bo'lib qolardi
    // va `'port' in payload` tekshiruvi yolg'on javob berardi.
    ...(typeof values.port === 'number' ? { port: values.port } : {}),
    ...(username === undefined ? {} : { username }),
    // ⚠️ Bo'sh parol tahrirlashda "tegilmasin" degani (`DeviceUpdate` izohi)
    ...(password === undefined ? {} : { password }),
  }
}

/**
 * Qurilma formasining barcha maydonlari — `buildDeviceDraft` va
 * `buildDeviceUpdate` uchun yagona kirish shakli.
 */
export interface DeviceFormInput extends ConnectionFormInput {
  name: string
  timeZone: string
  fdId: string
  doorNo: number
  direction: DeviceDirection
  /** Joylashuv reyestriga havola; `null`/bo'sh — "biriktirilmagan" */
  siteId?: string | null
  /** `host:port` bitta maydonda — `parseWebhookAddress` izohi */
  webhookAddress?: string | null
}

/**
 * `PUT`/`POST` tanasining UMUMIY qismi.
 *
 * <h2>⚠️⚠️ NEGA BU FUNKSIYA — MA'LUMOT YO'QOTISH TARIXI</h2>
 * `PUT /api/attendance/devices/{id}` — TO'LIQ ALMASHTIRISH
 * (`DeviceUpdate` javadoc'i: «berilgan maydonlar ustiga yoziladi,
 * `siteId` berilmasa TOZALANADI»). Bazada u shartsiz yoziladi:
 * `site_id = CAST(:siteId AS uuid)`, `COALESCE` yo'q.
 *
 * Forma `siteId` ni UMUMAN yubormas edi, ya'ni qurilma nomini tuzatish
 * uning JOYLASHUVINI jimgina o'chirib yuborardi — hech qanday xatosiz.
 * Uzilish haqida qo'ng'iroq kelganda "bu terminal qayerda?" degan
 * savolga javob shu tariqa yo'qolardi (`SiteRef` sarlavhasi aynan shu
 * nosozlik haqida).
 *
 * Shuning uchun so'rov tanasi QO'LDA yig'ilmaydi va bu funksiya
 * `buildConnectionPayload` bilan bir xil sababga ega: maydon tushib
 * qolishi KOMPONENTDA emas, SHU YERDA — chaqirib o'lchash mumkin
 * bo'lgan joyda — hal qilinadi.
 *
 * ⚠️ `siteId` HAR DOIM yuboriladi, `null` bo'lganda ham: tanlovni
 * tozalash ("joylashuvsiz qurilma") — HAQIQIY amal, chunki ustunda
 * `NOT NULL` yo'q va `DeviceDraft.siteId` ixtiyoriy. Maydonni tashlab
 * ketish bilan `null` yuborish serverda BIR XIL natija beradi, lekin
 * BOSHQA ma'noga ega: birinchisi tasodif, ikkinchisi qaror.
 */
function buildDeviceCommon(values: DeviceFormInput) {
  // ⚠️ `undefined` (bo'sh maydon) -> `null`: server buni «global
  // sozlamani ishlat» deb o'qiydi (`DeviceUpdate.webhookHost` javadoc'i).
  const webhook = parseWebhookAddress(values.webhookAddress)
  const siteId = (values.siteId ?? '').trim()
  return {
    name: values.name.trim(),
    /*
      ⚠️⚠️ ULANISH MAYDONLARI SHU YERDA, QO'LDA EMAS. Tanlanmagan
      rejimning maydonlari so'rovda UMUMAN bo'lmaydi — ekrandan
      yashirishning o'zi yetarli emas edi: antd formasi oldin
      ko'rsatilgan maydonning qiymatini do'konida saqlab qolishi
      mumkin va u so'rovga qo'shilib ketardi.
    */
    ...buildConnectionPayload(values),
    timeZone: values.timeZone,
    fdId: values.fdId.trim(),
    doorNo: values.doorNo,
    // ⚠️ HAR DOIM yuboriladi — tahrirlashda u SERVER TALABI
    // (`@NotNull`, maydonsiz so'rov 400 oladi).
    direction: values.direction,
    siteId: siteId === '' ? null : siteId,
    webhookHost: webhook ? webhook.host : null,
    webhookPort: webhook ? webhook.port : null,
  }
}

/** Yaratish tanasi — `deviceId` faqat shu yerda (`DeviceUpdate` da bunday maydon yo'q) */
export function buildDeviceDraft(values: DeviceFormInput, deviceId: string): DeviceDraft {
  return { ...buildDeviceCommon(values), deviceId: deviceId.trim() }
}

/** Tahrirlash tanasi — `active` faqat shu yerda (`DeviceDraft` da bunday maydon yo'q) */
export function buildDeviceUpdate(values: DeviceFormInput, active: boolean): DeviceUpdate {
  return { ...buildDeviceCommon(values), active }
}

export async function createDevice(draft: DeviceDraft): Promise<AttendanceDevice> {
  const response = await api.post<unknown>('/api/attendance/devices', draft)
  assertNoPassword(response.data)
  return parseDevice(response.data)
}

/**
 * Tahrir natijasi — qator VA amalning holati.
 *
 * ⚠️ `AttendanceDevice` EMAS (2026-08-15, D4). `ISUP_GATEWAY → DIRECT_ISAPI`
 * o'tishida gateway'dan o'chirish yiqilsa tahrir BAJARILADI, lekin gateway
 * ro'yxatida yetim yozuv qoladi — natija `PARTIAL`. Ilgari javob faqat
 * qurilma edi, ya'ni panelda bu holatni ko'rsatadigan joy YO'Q edi va
 * foydalanuvchi yashil «saqlandi» xabarini olardi.
 */
export interface DeviceUpdateResult {
  device: AttendanceDevice
  result: OperationResult
}

export async function updateDevice(id: string, draft: DeviceUpdate): Promise<DeviceUpdateResult> {
  const response = await api.put<unknown>(`/api/attendance/devices/${id}`, draft)
  // ⚠️ Parol tekshiruvi endi ICHKI obyektga qo'llanadi: `response.data` —
  // o'ram (`{device, result}`), qurilmaning o'zi emas.
  const body = (response.data ?? {}) as { device?: unknown; result?: unknown }
  assertNoPassword(body.device)
  return {
    device: parseDevice(body.device),
    result: operationResultSchema.parse(body.result),
  }
}

export async function deleteDevice(id: string): Promise<OperationResult> {
  const response = await api.delete<unknown>(`/api/attendance/devices/${id}`)
  return operationResultSchema.parse(response.data)
}

// --- Ulash ma'lumotlari (ISUP) -----------------------------------------------

/**
 * Kamera menyusiga TERILADIGAN to'rtta qiymatning server tomondagi ikkitasi.
 *
 * ⚠️ SERVER MANZILI VA PORTI QOTIRILMAYDI. Ular o'rnatmaga bog'liq
 * (`attendance.gateway.isup-host` / `isup-port`) va ularni panelga yozib
 * qo'yish eng zararli turdagi yolg'on bo'lardi: ekranda «to'g'ri»
 * ko'rinadigan, lekin boshqa o'rnatmada MAVJUD BO'LMAGAN manzil. Texnik
 * uni kameraga teradi, kamera jimgina ulanmaydi va sababi hech qayerda
 * yozilmaydi.
 */
export interface GatewaySettings {
  isupHost: string
  isupPort: number
}

const gatewaySettingsSchema = z.object({
  isupHost: z.string(),
  isupPort: z.number(),
})

/**
 * ISUP server manzili va porti.
 *
 * ⚠️⚠️ BU YO'L BACKEND BILAN HALI TASDIQLANMAGAN (2026-08-14). Backend
 * agenti ayni paytda shu bo'limni yozyapti. Shuning uchun panel bu
 * so'rovning YIQILISHIGA TAYYOR: `ConnectionInfoModal` xato holatida
 * Device ID va kalitni BARIBIR ko'rsatadi, manzil o'rniga esa «server
 * sozlamasi hali olinmadi» deb yozadi.
 *
 * Muqobil variant (qiymatni qotirib qo'yish yoki `localhost` kabi
 * to'ldiruvchi ko'rsatish) RAD ETILDI: yuqoridagi izohdagi sabab.
 */
export async function fetchGatewaySettings(): Promise<GatewaySettings> {
  const response = await api.get<unknown>('/api/attendance/gateway/settings')
  return gatewaySettingsSchema.parse(response.data)
}

const isupKeySchema = z.object({ isupKey: z.string() })

/**
 * Qurilmaning ISUP kalitini ALOHIDA so'rov bilan oladi.
 *
 * ⚠️ NEGA RO'YXAT JAVOBIDA EMAS. Kalit — gateway'ga ulanish siri. Uni har
 * bir ro'yxat so'rovida yuborish uni brauzer keshiga, tarmoq paneliga va
 * proksi log'iga tarqatardi; backendda esa «kim ko'rdi» degan savolga
 * javob qolmasdi. Alohida endpoint aynan shuning uchun: backend uni
 * AUDIT qiladi.
 *
 * ⚠️ Bu «yashirin sir» EMAS. Kalit ataylab uzatiladigan ma'lumot: admin
 * uni o'qib texnikka aytadi, texnik kamera menyusiga teradi. Shuning
 * uchun oynada u OCHIQ ko'rsatiladi va nusxa olinadi — yulduzcha ortiga
 * yashirish bu ekranning butun maqsadini bekor qilardi.
 */
export async function fetchIsupKey(id: string): Promise<string> {
  const response = await api.get<unknown>(`/api/attendance/devices/${id}/isup-key`)
  return isupKeySchema.parse(response.data).isupKey
}

/**
 * Gateway RAD ETGANDA sababini aniqlaydi.
 *
 * <h2>⚠️ NEGA BU KERAK — o'lchangan xulq</h2>
 * Gateway `addDevice` da HTTP **200** qaytarib, javob TANASIDA
 * `status: "fail"` deyishi mumkin. Ya'ni «muvaffaqiyatli» so'rov aslida
 * muvaffaqiyatsiz. Backend buni xatoga aylantiradi, lekin sabab bitta
 * texnik so'z bo'lib keladi (`deviceExist`) — va u operatorga NIMA
 * QILISHNI aytmaydi.
 *
 * Uch sabab va ularning uchalasi ham operator TUZATA OLADIGAN holat:
 *   `deviceExist`          — bu ID gateway'da bor → boshqasini yarating
 *   `badParameters`        — ID yoki kalit shakli noto'g'ri
 *   `monitorNodeOverLimit` — gateway to'lgan → bu operator ishi emas,
 *                            lekin u buni BILISHI kerak
 *
 * ⚠️ SABAB `tag` DA HAM, MATNDA HAM QIDIRILADI. Backend uni qaysi
 * maydonda berishi hali kelishilmagan (2026-08-14), ikkalasini ham
 * qarash esa ikki xil shartnomada bir xil ishlaydi. Topilmasa `null` —
 * o'shanda odatiy `translateError` yo'li ishlaydi va HECH QANDAY xabar
 * yo'qolmaydi.
 */
export const GATEWAY_ERROR_CODES = ['deviceExist', 'badParameters', 'monitorNodeOverLimit'] as const
export type GatewayErrorCode = (typeof GATEWAY_ERROR_CODES)[number]

export function gatewayErrorCode(error: unknown): GatewayErrorCode | null {
  const parts: string[] = []
  if (error !== null && typeof error === 'object') {
    const maybe = error as { tag?: unknown; message?: unknown; response?: unknown }
    if (typeof maybe.tag === 'string') parts.push(maybe.tag)
    if (typeof maybe.message === 'string') parts.push(maybe.message)
    const body = (maybe.response as { data?: { error?: { tag?: unknown; text?: unknown } } } | undefined)
      ?.data?.error
    if (typeof body?.tag === 'string') parts.push(body.tag)
    if (typeof body?.text === 'string') parts.push(body.text)
  }
  /*
    ⚠️ REGISTR VA AJRATUVCHILAR TASHLANADI. Gateway `deviceExist` deydi,
    backend esa uni o'z tagiga o'girganda `GATEWAY_DEVICE_EXIST` yoki
    `device-exist` qilishi mumkin — bu loyihada taglar SNAKE_CASE
    (`NOT_FOUND`, `CONSTRAINT_23505`). Faqat `toLowerCase()` bilan
    solishtirish o'shanda JIMGINA ishlamay qolardi: sinov yashil,
    operator esa umumiy xato ko'rardi.
  */
  const normalise = (value: string) => value.toLowerCase().replace(/[^a-z0-9]/g, '')
  const haystack = normalise(parts.join(' '))
  return GATEWAY_ERROR_CODES.find((code) => haystack.includes(normalise(code))) ?? null
}

// --- Ulanishni tekshirish ----------------------------------------------------

/**
 * Probe natijasi — qurilmaga HOZIR yuborilgan chaqiruvning javobi.
 *
 * ⚠️ Jadvaldagi `status` USTUNIDAN BOSHQA SAVOL. Ustun fon jarayoni
 * qoldirgan OXIRGI ma'lum holat (`device.status`, davriy tekshiruv
 * natijasi), bu esa "hozir, shu daqiqada" degan savol. Ikkalasi turlicha
 * bo'lishi mutlaqo odatiy: qurilma bir daqiqa oldin qayta yuklangan
 * bo'lishi mumkin. Aynan shu farq `NasPage` da ham bor va u yerda
 * jonli o'rnatmada bir necha soat izlanishni tejagan.
 *
 * Holat qiymatlari `DEVICE_STATUSES` dan QAYTA ISHLATILADI. Ikkinchi
 * lug'at yaratish (masalan `ALIVE`/`BAD_CREDENTIALS`) operatorni bir xil
 * narsani ikki xil nom bilan o'qishga majbur qilardi. `UNKNOWN` amalda
 * kutilmaydi (probe har doim aniq javob beradi), lekin enum'dan
 * chiqarilmaydi: kutilmagan qiymat zod xatosi bo'lib yiqilgandan ko'ra,
 * "hali tekshirilmagan" bo'lib ko'ringani xavfsizroq.
 */
const deviceProbeSchema = z.object({
  status: z.enum(DEVICE_STATUSES),
  /**
   * ⚠️ SABAB OCHIQ MATN BILAN, "xato" degan umumiy so'z bilan EMAS.
   * "Ulanmadi" operatorga nima qilish kerakligini aytmaydi; "Digest
   * autentifikatsiya rad etildi (401)" yoki "10.231.169.203:80 — ulanish
   * vaqti tugadi" esa aytadi. Server bu matnni o'zi tayyorlaydi, chunki
   * qurilmaning javobini u ko'rgan.
   */
  detail: z.string().nullish(),
  /** Model, seriya, proshivka — ro'yxatdagi bilan bir xil shakl */
  deviceInfo: deviceInfoSchema.nullish(),
  /**
   * ⚠️ QURILMA AYTGAN vaqt, XOM holda: `2026-08-11T16:39:32+08:00`.
   * Ofseti bilan birga saqlanadi va shu holda ko'rsatiladi — "to'g'rilab"
   * o'girish aynan tekshirilayotgan nosozlikni ko'rinmas qilardi.
   */
  deviceLocalTime: z.string().nullish(),
  /**
   * Qurilma e'lon qilgan zona satri, xom holda (`+08:00`, `CST-8:00:00`).
   * 2026-08-11 dagi hodisaning ISBOTI aynan shu maydonda: qurilma
   * Toshkent vaqtini ko'rsatib turib uni `+08:00` deb belgilagan.
   */
  deviceTimeZoneRaw: z.string().nullish(),
  clockSkewSeconds: z.number().nullish(),
  probedAt: instantSchema.nullish(),
})

export interface DeviceProbeResult {
  status: DeviceStatus
  detail: string | null
  deviceInfo: DeviceInfo | null
  deviceLocalTime: string | null
  deviceTimeZoneRaw: string | null
  clockSkewSeconds: number | null
  probedAt: string | null
}

export async function probeDevice(id: string): Promise<DeviceProbeResult> {
  const response = await api.post<unknown>(`/api/attendance/devices/${id}/probe`, {})
  const raw = deviceProbeSchema.parse(response.data)
  return {
    status: raw.status,
    detail: raw.detail ?? null,
    deviceInfo: toDeviceInfo(raw.deviceInfo),
    deviceLocalTime: raw.deviceLocalTime ?? null,
    deviceTimeZoneRaw: raw.deviceTimeZoneRaw ?? null,
    clockSkewSeconds: raw.clockSkewSeconds ?? null,
    probedAt: raw.probedAt ?? null,
  }
}

/**
 * Eshikni masofadan ochish.
 *
 * ⚠️ JISMONIY AMAL: bu yerda bosilgan tugma haqiqiy eshikni ochadi.
 * Shuning uchun (a) alohida huquq (`attendance.door.open`), (b) UI'da
 * tasdiqlash so'raladi. Natija `OperationResult` — qurilmaga chaqiruv
 * ketgani "eshik ochildi" degani emas, va buni "muvaffaqiyatli" deb
 * soddalashtirish yolg'on bo'lardi.
 */
export async function openDoor(id: string): Promise<OperationResult> {
  const response = await api.post<unknown>(`/api/attendance/devices/${id}/open-door`, {})
  return operationResultSchema.parse(response.data)
}

/**
 * Webhook manzilini QURILMAGA yozish.
 *
 * ⚠️ Bu «saqlash» EMAS. Manzil bazada allaqachon turadi (`webhookHost` /
 * `webhookPort` yoki global sozlama); bu tugma qurilmaning O'ZIGA
 * «hodisalarni mana bu manzilga yubor» deb yozadi
 * (`PUT /ISAPI/Event/notification/httpHosts/1`) va natijani QAYTA O'QIB
 * tasdiqlaydi.
 *
 * ⚠️ Nega alohida tugma, saqlashga qo'shib yuborilmagan: qurilma o'sha
 * paytda yetib bo'lmaydigan holatda bo'lishi mumkin va o'shanda
 * saqlashning o'zi ham yiqilardi. Manzilni bazaga yozish — ma'lumot
 * ishi, qurilmaga yozish — tarmoq amali; ularni bog'lash birinchisini
 * ikkinchisining ishonchsizligiga bog'lab qo'yardi.
 *
 * ⚠️ `OperationResult` — uch holat va uchalasi ham HAQIQIY:
 *   OK      — yozildi va qurilmada tasdiqlandi
 *   PARTIAL — qurilma so'rovni qabul qildi, lekin qayta o'qishda
 *             manzil boshqacha ko'rindi. Push ishlamasligi mumkin,
 *             pull esa baribir ishlaydi (SARIQ ko'rsatiladi)
 *   FAILED  — manzil yo'q, qurilma rad etdi yoki yetib bo'lmadi
 */
export async function configureWebhook(id: string): Promise<OperationResult> {
  const response = await api.post<unknown>(`/api/attendance/devices/${id}/webhook`, {})
  return operationResultSchema.parse(response.data)
}

/**
 * `host:port` satrini ikkiga ajratadi — forma maydoni uchun.
 *
 * ⚠️ Nega BITTA maydon: operator serverning manzilini aynan shu shaklda
 * biladi (`10.10.10.12:18116`, `davomat.example.uz:443`). Ikkita alohida
 * maydon uni qiymatni bo'lishga majbur qilardi va port maydonini bo'sh
 * qoldirish eng ko'p uchraydigan xato bo'lardi.
 *
 * ⚠️ Port MAJBURIY va bu ataylab: bazada `device_webhook_pair` cheklovi
 * bor (host bilan port birga yoki ikkalasi ham yo'q). Portsiz qiymatni
 * jimgina global portga to'ldirish operatorni «men kiritgan manzil
 * ishlatilyapti» deb o'ylashga majbur qilardi.
 *
 * @returns `null` — shakl noto'g'ri; `undefined` — qiymat bo'sh
 *          (global sozlama ishlatiladi)
 */
export function parseWebhookAddress(
  value: string | undefined | null,
): { host: string; port: number } | null | undefined {
  const trimmed = (value ?? '').trim()
  if (trimmed === '') return undefined

  const separator = trimmed.lastIndexOf(':')
  if (separator <= 0 || separator === trimmed.length - 1) return null

  const host = trimmed.slice(0, separator).trim()
  const port = Number(trimmed.slice(separator + 1).trim())
  if (host === '' || !Number.isInteger(port) || port < 1 || port > 65535) return null
  // ⚠️ Host shakli BU YERDA tekshirilmaydi: u IP ham, subdomen ham
  // bo'lishi mumkin (backend `addressingFormatType` ni qiymatning
  // o'zidan aniqlaydi). Bu yerda regex yozish ikkita qoidani yaratardi
  // va ular bir kun ajralib ketardi.
  return { host, port }
}

/** `host:port` — formani to'ldirish uchun teskari amal. */
export function formatWebhookAddress(host: string | null, port: number | null): string {
  return host === null || port === null ? '' : `${host}:${port}`
}

// --- Mijoz tomonidagi tekshiruv ---------------------------------------------

/**
 * Qurilma vaqt zonasi uchun tanlov.
 *
 * ⚠️ ERKIN MATN EMAS, YOPIQ RO'YXAT. Bu maydon hisobot kun chegarasini
 * belgilaydi va terilishdagi xato (`Asia/Tashkant`) butun hisobotni
 * jimgina siljitardi. Ro'yxat qisqa va amaliy: hamkorlar aynan shu
 * zonalarda ishlaydi (O'zbekiston UTC+5, Afg'oniston UTC+4:30), `UTC`
 * esa zaxira — qurilma zonasi noma'lum bo'lganda.
 */
export const DEVICE_TIME_ZONES = ['Asia/Kabul', 'Asia/Tashkent', 'UTC'] as const

/** IPv4 — qurilma manzili host nomi bo'lishi mumkin emas (`device.ip_address` = `INET`) */
const IPV4_OCTET = '(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)'
const IPV4 = new RegExp(`^${IPV4_OCTET}(\\.${IPV4_OCTET}){3}$`)

/**
 * ⚠️ NEGA MIJOZDA TEKSHIRILADI: ustun turi `INET`, ya'ni server xato
 * qiymatni baribir rad etadi — lekin xabar baza darajasidagi tushunarsiz
 * matn bo'lib qaytardi. Bu yerdagi tekshiruv operatorga AYNAN nima
 * noto'g'ri ekanini aytadi.
 */
export function isValidIpv4(value: string): boolean {
  return IPV4.test(value.trim())
}

/**
 * Xodim raqami emas, QURILMA belgisi (`device_id`) uchun tekshiruv.
 *
 * Bo'sh bo'lmasin va bo'sh joy bo'lmasin — u tenant ichida yagona kalit
 * (`device_code_uq`) va odam tomonidan yoziladi, ya'ni oxiridagi ko'rinmas
 * probel "bunday qurilma yo'q" degan chalkashlikka olib kelardi.
 */
export function isValidDeviceCode(value: string): boolean {
  const trimmed = value.trim()
  return trimmed !== '' && !/\s/.test(trimmed)
}

/**
 * ISUP raqami (`EhomeID`) va kaliti (`EhomeKey`) uchun chegaralar —
 * ISUP hujjati A.25 dagi izohlarning aynan o'zi:
 *
 *   `EhomeID`   /\*required, max 31, raqam va harf\*\/
 *   `EhomeKey`  /\*depends on protocolType being ehomeV5, max 32\*\/
 *
 * ⚠️ CHEGARA MIJOZDA TEKSHIRILADI, garchi uni gateway ham rad etsa ham.
 * Sabab `isValidIpv4` dagi bilan bir xil: gateway'ning rad javobi
 * `badParameters` degan bitta so'z, va u operatorga QAYSI maydon,
 * QANCHA belgi ekanini aytmaydi. Bu yerdagi tekshiruv aytadi — va u
 * so'rov umuman ketishidan oldin aytadi.
 */
export const ISUP_DEVICE_ID_MAX = 31
export const ISUP_KEY_MAX = 32

/**
 * Qurilmada sozlangan ISUP raqami (`isupDeviceId` / `EhomeID`).
 *
 * ⚠️ Ro'yxat YOPIQ: FAQAT raqam va lotin harfi. Bu bizning injiqligimiz
 * emas — hujjatda aynan shunday yozilgan va gateway boshqasini
 * `badParameters` bilan rad etadi. Chiziqcha yoki pastki chiziq qo'shgan
 * operator sababini hech qayerdan bilmasdi.
 *
 * ⚠️ Ko'chirib qo'yishda ilashgan probel eng yomon turdagi xato: qiymat
 * ekranda TO'G'RI ko'rinadi, lekin gateway uni topa olmaydi va qurilma
 * abadiy "ro'yxatdan o'tmagan" bo'lib qoladi. Atrofdagi bo'shliq
 * kesiladi, ICHKI bo'shliq esa rad etiladi (regexdan o'tmaydi).
 */
export function isValidIsupDeviceId(value: string): boolean {
  const trimmed = value.trim()
  return trimmed !== '' && trimmed.length <= ISUP_DEVICE_ID_MAX && /^[A-Za-z0-9]+$/.test(trimmed)
}

/**
 * ISUP kaliti (`isupKey` / `EhomeKey`) — gateway'ga ulanish SIRI.
 *
 * ⚠️ BELGILAR RO'YXATI QOTIRILMAYDI, faqat uzunlik va bo'shliq
 * tekshiriladi. `isupDeviceId` dan farqi ataylab: hujjat kalit uchun
 * FAQAT uzunlikni belgilaydi. Sir uchun ortiqcha qoida o'ylab topish
 * haqiqiy kalitni rad etardi — va operator buni tuzata olmasdi, chunki
 * kalit qurilmada allaqachon qo'yilgan.
 */
export function isValidIsupKey(value: string): boolean {
  const trimmed = value.trim()
  return trimmed !== '' && trimmed.length <= ISUP_KEY_MAX && !/\s/.test(trimmed)
}

// --- Qiymat yaratish ---------------------------------------------------------

/**
 * Yaratiladigan qiymatlar ALIFBOSI — CHALKASHADIGAN BELGILAR OLIB TASHLANGAN.
 *
 * <h2>⚠️ NEGA TO'LIQ ALIFBO EMAS</h2>
 * Bu qiymatni odam KAMERA MENYUSIDA QO'LDA TERADI — telefon ekranidan yoki
 * qog'ozdan o'qib. Ya'ni bu erkin matn emas, OG'ZAKI uzatiladigan qiymat.
 *
 * Chiqarilganlar va sababi:
 *   `0` va `O` — bir xil ko'rinadi, ayniqsa kichik shriftda
 *   `1`, `l`, `I` — uchalasi ham tik chiziq
 *
 * Ularning birini qoldirish YETARLI EMAS: texnik `O` ni ko'rib `0` teradi
 * va gateway `deviceExist` emas, JIMGINA "qurilma ulanmadi" beradi —
 * sababi esa hech qayerda yozilmaydi. Shuning uchun juftlikning IKKALASI
 * ham alifbodan chiqarildi.
 *
 * ⚠️ FAQAT KATTA HARF: kamera menyusida registr almashtirish qo'shimcha
 * qadam va yana bitta xato manbai. `EhomeID` uchun hujjat «raqam va harf»
 * deydi, registrni cheklamaydi — ya'ni bu bizning tanlovimiz va u
 * TERISH qulayligi uchun qilingan.
 */
export const SAFE_ALPHABET = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ'

/** `EhomeID` ning o'qiladigan qismi — qaysi tizim yaratganini aytadi */
export const ISUP_DEVICE_ID_PREFIX = 'XSIB'
/** Prefiksdan keyingi tasodifiy qism */
export const ISUP_DEVICE_ID_RANDOM_LENGTH = 8
/**
 * Kalit uzunligi — 16, garchi `EhomeKey` 32 gacha ruxsat bersa ham.
 *
 * ⚠️ ATAYLAB CHEGARADAN KICHIK. 32 belgini qo'lda terishda xato ehtimoli
 * ikki barobar oshadi, va bu xato JIMGINA bo'ladi: kamera hech narsa
 * demaydi, u shunchaki gateway'ga ulanmaydi. 32 belgilik alifboda 16
 * belgi ≈ 80 bit — qo'pol kuch bilan topib bo'lmaydi, ya'ni qisqartirish
 * qulaylik uchun xavfsizlikni sotish EMAS.
 */
export const ISUP_KEY_LENGTH = 16

/**
 * Kriptografik tasodifiy satr — `SAFE_ALPHABET` dan.
 *
 * ⚠️ `Math.random()` ISHLATILMAYDI. U kalit yaratish uchun mo'ljallanmagan
 * va bashorat qilinadi; bu yerda esa qurilmaning gateway'ga ulanish siri
 * yaratilyapti.
 *
 * ⚠️ MODULO SIQIQLIGI OLDI OLINGAN: `% 32` emas, bayt `256 - (256 % 32)`
 * chegarasidan oshsa TASHLAB yuboriladi. 32 — 256 ning bo'luvchisi, ya'ni
 * hozircha siqiqlik yo'q; lekin alifbo uzunligi bir kun o'zgarsa (masalan
 * yana bitta harf chiqarilsa) `%` jimgina ayrim belgilarni ko'proq
 * chiqara boshlardi va buni hech kim sezmasdi.
 */
function randomText(length: number): string {
  const alphabet = SAFE_ALPHABET
  const limit = 256 - (256 % alphabet.length)
  let out = ''
  const buffer = new Uint8Array(length * 2)
  while (out.length < length) {
    crypto.getRandomValues(buffer)
    for (const byte of buffer) {
      if (byte >= limit) continue
      out += alphabet[byte % alphabet.length]
      if (out.length === length) break
    }
  }
  return out
}

/**
 * Yangi `EhomeID` — `XSIB` + 8 tasodifiy belgi (jami 12, chegara 31).
 *
 * ⚠️ TIZIM TAKLIF QILADI, admin XOHLASA O'ZGARTIRADI (egasi qarori).
 * Majburiy qilish mumkin emas edi: kamera boshqa tizimda allaqachon
 * ro'yxatdan o'tgan bo'lishi va o'sha ID ni saqlab qolish kerak bo'lishi
 * mumkin.
 */
export function generateIsupDeviceId(): string {
  return ISUP_DEVICE_ID_PREFIX + randomText(ISUP_DEVICE_ID_RANDOM_LENGTH)
}

/** Yangi `EhomeKey` — 16 belgi (izoh `ISUP_KEY_LENGTH` da) */
export function generateIsupKey(): string {
  return randomText(ISUP_KEY_LENGTH)
}

// =============================================================================
// XODIMLAR, HODISALAR, HISOBOT
//
// Bu bo'lim AVVAL migratsiyadan (`V202608110100__attendance_init.sql`)
// taxmin qilib yozilgan edi — o'shanda backend DTO'lari hali yo'q edi.
// KEYIN haqiqiy DTO'lar bilan solishtirildi. Natija shu yerda yozib
// qoldiriladi, chunki taxminlarning qaysi biri to'g'ri chiqqani keyingi
// safar qaysi manbaga ishonish kerakligini aytadi:
//
//   ✅ `Employee.sync` — nomi ham, shakli ham to'g'ri taxmin qilingan
//      (`List<EmployeeSyncStatus>`). Jadval ustunidan chiqarish ISHLADI.
//
//   ❌ KUNLIK HISOBOT — `firstIn`/`lastOut` deb olingan edi, aslida
//      `firstInAt`/`lastOutAt`. Oqibati JIMGINA bo'lardi va eng yomon
//      turdagi: `.nullish()` tufayli zod xato BERMASDI, vaqtlar bo'sh
//      chiqardi va holat har qatorda "KELMAGAN" bo'lib ko'rinardi —
//      ya'ni hisobot ishlayotgandek turib, butunlay yolg'on gapirardi.
//
//   ❌ OYLIK HISOBOT — "xodim × oy YAKUNI" deb olingan edi, aslida
//      "BITTA XODIMNING KUNLARI" (yoki xodim tanlanmasa, butun tashkilot
//      bo'yicha KUNLIK yig'indi). Ya'ni taxmin shakli emas, savolning
//      O'ZINI noto'g'ri tushungan edi.
//
// ⚠️ SABOQ: jadval ustuni DTO maydonining ISHONCHLI manbai emas. U faqat
// jadval bilan bir-bir mos keladigan yozuvlarda ishlaydi (`employee`,
// `device`). Hisobot esa jadval EMAS — u hisoblangan javob, va uning
// maydonlari jadvalda umuman yo'q (`workedMinutes`, `nightShiftSuspected`,
// `unidentifiedDeniedCount`). Bunday joyda taxmin qilish o'rniga kutish
// kerak edi.
//
// ⚠️ MASSIV MAYDONI HAMMA YERDA `rows` — hisobotda ham, sahifada ham
// (2026-08-14 dan beri; ilgari sahifada `items` edi va bu yerda
// "ular boshqa-boshqa" deb tushuntirilgandi). Farq faqat qo'shni
// maydonlarda qoldi:
//   · `DevicePage`/`EmployeePage`/`EventPage` — SAHIFA: `rows` + `total`
//     + `page` + `size`
//   · `DailyReport`/`MonthlyReport`/`LastSeenReport`/`PresentReport`
//     — HISOBOT: `rows` + yig'indilar + `notes`, sahifalash YO'Q
// Ya'ni "`rows` bormi" degan savol endi shaklni ajratmaydi — `page`
// bor-yo'qligiga qarang (`tests/api-contract.mjs` §4 ham shunday
// ajratadi).
// =============================================================================

// --- Xodimlar ----------------------------------------------------------------

/**
 * Sinxron holati — `sync_state_valid` cheklovidagi UCH qiymatning aynan o'zi.
 *
 * ⚠️ Bu YAGONA joyki, bu bo'limda `z.enum` QOTIRILGAN: qiymatlar taxmin
 * emas, bazadagi `CHECK (state IN ('PENDING', 'SYNCED', 'FAILED'))` dan
 * ko'chirilgan. To'rtinchi qiymat paydo bo'lsa u migratsiyasiz paydo
 * bo'lolmaydi, ya'ni zod xatosi to'g'ri signal bo'ladi.
 */
export const SYNC_STATES = ['PENDING', 'SYNCED', 'FAILED'] as const
export type SyncState = (typeof SYNC_STATES)[number]

/**
 * Xodim × qurilma mosligi — `attendance.device_employee_sync` qatori.
 *
 * ⚠️ IKKI QADAM ALOHIDA (`userSyncedAt` va `faceSyncedAt`) va ularni
 * bittaga birlashtirish TAKLIFI RAD ETILADI. Qurilmaga ikki chaqiruv
 * ketadi — avval foydalanuvchi yozuvi, keyin yuz rasmi — va birinchisi
 * o'tib, ikkinchisi yiqilishi ODATIY hol (yuz sifati past bo'lsa aynan
 * shunday bo'ladi). Bitta bayroq bo'lsa panel "sinxronlanmadi" derdi,
 * holbuki xodim qurilmada BOR, faqat yuzisiz — va bu butunlay boshqa
 * vaziyat, boshqa harakat talab qiladi.
 *
 * ⚠️ `lastSubStatus` — QURILMANING O'Z kodi (`lowFaceQuality`,
 * `outOfMaxRecordNum`), xom holda. U hech qachon "tarjima" qilinmaydi va
 * umumiy matn bilan almashtirilmaydi: `lowFaceQuality` operatorga nima
 * qilish kerakligini aytadi ("boshqa rasm yuklang"), "sinxronlash
 * muvaffaqiyatsiz" esa hech narsa demaydi.
 */
const employeeSyncSchema = z.object({
  deviceId: uuidSchema,
  /** Server JOIN bilan qo'shadi — bazada bu ustun yo'q */
  deviceName: z.string().nullish(),
  state: z.enum(SYNC_STATES),
  /** `UPSERT` = qurilmada bo'lsin, `DELETE` = qurilmadan o'chirilsin */
  desiredAction: z.string().nullish(),
  attempts: z.number().nullish(),
  lastError: z.string().nullish(),
  lastSubStatus: z.string().nullish(),
  userSyncedAt: instantSchema.nullish(),
  faceSyncedAt: instantSchema.nullish(),
  nextAttemptAt: instantSchema.nullish(),
})

export interface EmployeeSyncState {
  deviceId: string
  deviceName: string | null
  state: SyncState
  desiredAction: string | null
  attempts: number | null
  lastError: string | null
  lastSubStatus: string | null
  userSyncedAt: string | null
  faceSyncedAt: string | null
  nextAttemptAt: string | null
}

/*
  ⚠️ `tenantId` SXEMADA ATAYLAB YO'Q — qurilmadagi bilan bir xil sabab
  (javob allaqachon faqat o'z tashkilotining yozuvlaridan iborat).

  ⚠️ RASM BAYTLARI HAM YO'Q va bu MUHIMROQ. 2026-08-16 dan rasm bazada
  (`attendance.employee_photo`, ADR-027), lekin u ro'yxat javobiga
  HECH QACHON qo'shilmaydi: ellikta xodimning rasmi bitta sahifani
  o'nlab megabaytga aylantirardi. Panelga faqat "rasm BORMI" degan
  javob kerak va u `photoSha256` dan chiqadi; rasmning o'zini `/photo`
  endpointi beradi.

  (Ilgari bu yerda `photoPath` — serverdagi fayl yo'li — bor edi;
  u server javobidan butunlay olib tashlandi.)
*/
const employeeSchema = z.object({
  id: uuidSchema,
  /**
   * ⚠️ QURILMADAGI YAGONA KALIT (`employeeNoString`). Faqat raqam va
   * ko'pi bilan 32 belgi — bu bazadagi `employee_no_numeric` cheklovi,
   * u esa Hikvision talabining ko'zgusi.
   */
  employeeNo: z.string(),
  fullName: z.string(),
  active: z.boolean(),
  validFrom: instantSchema.nullish(),
  validTo: instantSchema.nullish(),
  /** Rasm bormi degan savolga javob. Rasmning O'ZI alohida endpointda. */
  photoSha256: z.string().nullish(),
  personRef: uuidSchema.nullish(),
  createdAt: instantSchema.nullish(),
  updatedAt: instantSchema.nullish(),
  /**
   * ⚠️ NOMI TAXMIN QILINGAN (bo'limning sarlavhasidagi ogohlantirish).
   * Shuning uchun `.nullish()`: nom boshqacha chiqsa ro'yxat BARIBIR
   * ochiladi, faqat sinxron ustuni bo'sh bo'ladi — va buni ustunning
   * o'zi aytadi ("ma'lumot yo'q"), sahifa esa yiqilmaydi.
   */
  sync: z.array(employeeSyncSchema).nullish(),
})

export interface AttendanceEmployee {
  id: string
  employeeNo: string
  fullName: string
  active: boolean
  validFrom: string | null
  validTo: string | null
  /** `photoSha256` dan chiqariladi — panelga yo'l emas, shu javob kerak */
  hasPhoto: boolean
  photoSha256: string | null
  personRef: string | null
  createdAt: string | null
  updatedAt: string | null
  /** `null` = server bu ma'lumotni umuman bermadi ("hech bir qurilmada yo'q" EMAS) */
  sync: readonly EmployeeSyncState[] | null
}

function toSyncState(raw: z.infer<typeof employeeSyncSchema>): EmployeeSyncState {
  return {
    deviceId: raw.deviceId,
    deviceName: raw.deviceName ?? null,
    state: raw.state,
    desiredAction: raw.desiredAction ?? null,
    attempts: raw.attempts ?? null,
    lastError: raw.lastError ?? null,
    lastSubStatus: raw.lastSubStatus ?? null,
    userSyncedAt: raw.userSyncedAt ?? null,
    faceSyncedAt: raw.faceSyncedAt ?? null,
    nextAttemptAt: raw.nextAttemptAt ?? null,
  }
}

function toEmployee(raw: z.infer<typeof employeeSchema>): AttendanceEmployee {
  return {
    id: raw.id,
    employeeNo: raw.employeeNo,
    fullName: raw.fullName,
    active: raw.active,
    validFrom: raw.validFrom ?? null,
    validTo: raw.validTo ?? null,
    hasPhoto: Boolean(raw.photoSha256),
    photoSha256: raw.photoSha256 ?? null,
    personRef: raw.personRef ?? null,
    createdAt: raw.createdAt ?? null,
    updatedAt: raw.updatedAt ?? null,
    // ⚠️ `undefined` → `null`, BO'SH MASSIV EMAS. Farqi ekranda ko'rinadi:
    // bo'sh massiv "hech bir qurilmaga yuborilmagan" (aniq fakt, harakat
    // talab qiladi), `null` esa "server aytmadi" (bilmaymiz). Ikkinchisini
    // birinchisiga aylantirish operatorni mavjud bo'lmagan muammoni
    // tuzatishga yuborardi.
    sync: raw.sync ? raw.sync.map(toSyncState) : null,
  }
}

const employeePageSchema = z.object({
  rows: z.array(employeeSchema),
  total: z.number(),
  page: z.number(),
  size: z.number(),
})

/**
 * Xodimlar ro'yxati — `DataTable` kutgan shaklda.
 *
 * ⚠️ Sahifalash va qidiruv SERVERDA (`fetchDevicePage` bilan bir xil
 * qoida va bir xil sabab). Saralash serverda yo'q, shuning uchun
 * ustunlarda `sorter` qo'yilmagan.
 */
export async function fetchEmployeePage(
  state: TableState,
  signal: AbortSignal,
): Promise<PageResult<AttendanceEmployee>> {
  const search = state.search.trim()
  const response = await api.get<unknown>('/api/attendance/employees', {
    signal,
    params: { q: search === '' ? undefined : search, page: state.page - 1, size: state.pageSize },
  })
  const parsed = employeePageSchema.parse(response.data)
  return { items: parsed.rows.map(toEmployee), total: parsed.total }
}

/**
 * Yaratish uchun ma'lumot.
 *
 * ⚠️ `active` YO'Q — `DeviceDraft` bilan bir xil qaror: yangi xodim har
 * doim faol (`employee.active DEFAULT TRUE`). Nofaol xodim yaratish
 * stsenariysi amalda yo'q.
 *
 * ⚠️ `validFrom`/`validTo` ISO-8601 UTC. Ular qurilmaga `UserInfo.Valid`
 * bo'lib uzatiladi, ya'ni muddat tugagach eshik O'ZI ochilmay qoladi —
 * bu panel ko'rsatkichi emas, QURILMADAGI cheklov.
 */
export interface EmployeeDraft {
  employeeNo: string
  fullName: string
  validFrom?: string | null
  validTo?: string | null
}

/**
 * Tahrirlash.
 *
 * ⚠️ `employeeNo` BU YERDA YO'Q va bu `DeviceUpdate.deviceId` bilan aynan
 * bir xil qaror, lekin bu yerda oqibati OG'IRROQ. Tabel raqami uch joyda
 * kalit bo'lib ishlaydi:
 *   · qurilmada — `employeeNoString` (yagona identifikator)
 *   · hodisalarda — `event.employee_no`, MATN sifatida, FK'SIZ
 *   · hisobotda — xodim × kun kesimi shu ustun bo'yicha yig'iladi
 * Uni almashtirish qurilmadagi eski yozuvni yetim qoldirardi va butun
 * o'tmish davomat tarixi endi mavjud bo'lmagan odamga tegishli bo'lib
 * qolardi — jimgina, hech qanday xatosiz.
 */
export interface EmployeeUpdate extends Omit<EmployeeDraft, 'employeeNo'> {
  active: boolean
  /**
   * ⚠️ MAJBURIY va `Omit` dan tashqarida ATAYLAB.
   *
   * `PUT` — to'liq almashtirish: `JdbcEmployeeRepository` bu ustunni
   * `COALESCE` siz yozadi. Maydon yuborilmasa Jackson uni `null` qiladi
   * va HR-xodim bog'lanishi JIMGINA o'chadi — ism yoki muddatni tuzatgan
   * birinchi safar. Majburiy qilingani uchun tip tekshiruvi uni ushlaydi.
   */
  personRef: string | null
}

export async function createEmployee(draft: EmployeeDraft): Promise<AttendanceEmployee> {
  const response = await api.post<unknown>('/api/attendance/employees', draft)
  return toEmployee(employeeSchema.parse(response.data))
}

export async function updateEmployee(
  id: string,
  update: EmployeeUpdate,
): Promise<AttendanceEmployee> {
  const response = await api.put<unknown>(`/api/attendance/employees/${id}`, update)
  return toEmployee(employeeSchema.parse(response.data))
}

export async function deleteEmployee(id: string): Promise<OperationResult> {
  const response = await api.delete<unknown>(`/api/attendance/employees/${id}`)
  return operationResultSchema.parse(response.data)
}

/**
 * Xodimni qurilmalarga yuborish navbatiga qo'yish.
 *
 * ⚠️ NATIJA `OperationResult`, boolean EMAS — va bu yerda uch holatning
 * uchalasi ham HAQIQATAN uchraydi:
 *   OK      — qurilmaga yozildi
 *   PARTIAL — navbatga qo'yildi, lekin qurilma hozir javob bermadi
 *             (bu XATO EMAS: fon jarayoni qayta urinadi)
 *   FAILED  — navbatga ham qo'yib bo'lmadi
 * Ikkinchisini "muvaffaqiyatli" deb ko'rsatish operatorga xodim eshikdan
 * o'ta oladi degan yolg'on ishonch berardi.
 *
 * ⚠️ Huquq `attendance.device.sync` — `employee.write` dan ALOHIDA.
 * Sabab `permissions.ts` da: bu amal TASHQI qurilmaga chaqiruv qiladi va
 * noto'g'ri parolda Hikvision manzilni ~30 daqiqaga qulflaydi.
 */
export async function syncEmployee(id: string): Promise<OperationResult> {
  const response = await api.post<unknown>(`/api/attendance/employees/${id}/sync`, {})
  return operationResultSchema.parse(response.data)
}

// --- Foto --------------------------------------------------------------------

/**
 * Yuz rasmi uchun tavsiya etilgan eng katta hajm (bayt).
 *
 * ⚠️ BU PANELNING TAVSIYASI, SERVERNING QOIDASI EMAS — shuning uchun u
 * yuklashni TO'XTATMAYDI, faqat ogohlantiradi. Farq muhim: agar panel
 * o'zidan chegara qo'yib bloklasa va serverda chegara boshqacha bo'lsa,
 * operator serverda ishlaydigan rasmni yuklay olmasdi va sababini hech
 * qayerdan bilmasdi.
 *
 * 200 KB — Hikvision yuz kutubxonasi uchun amaliy chegara (migratsiya
 * izohida ~100 KB o'lchangan). Undan kattasi qurilmada
 * `outOfMaxRecordNum` yoki hajm xatosi bilan rad etilishi mumkin va
 * o'sha xato XOM holda ekranga chiqadi.
 */
export const EMPLOYEE_PHOTO_SOFT_MAX_BYTES = 200 * 1024

/**
 * ⚠️ FAQAT JPEG. Bu tanlov emas, qurilma talabi: Hikvision yuz
 * kutubxonasi PNG ni qabul qilmaydi. PNG'ni jimgina yuborish qurilmadan
 * tushunarsiz `subStatusCode` olib kelardi va operator sababni rasmning
 * O'ZIDA (yorug'lik, burchak) qidirardi — holbuki muammo formatda.
 */
export const EMPLOYEE_PHOTO_MIME = 'image/jpeg'

export function isJpeg(file: File): boolean {
  return file.type === EMPLOYEE_PHOTO_MIME || /\.jpe?g$/i.test(file.name)
}

/**
 * Yuz rasmini yuklash.
 *
 * ⚠️ `Content-Type` ATAYLAB O'CHIRILADI (`undefined`). Axios nusxasi
 * global `application/json` bilan yaratilgan (`shared/api/client.ts`) va
 * u multipart so'rovga ham qo'shilib ketardi — natijada brauzer
 * `boundary` ni QO'SHOLMAY qolardi va server tanani "bo'sh" deb o'qirdi.
 * Bu xato jimgina bo'ladi: so'rov 200 qaytarishi ham mumkin, rasm esa
 * yo'q. Sarlavhani olib tashlash brauzerga uni to'g'ri qiymat bilan
 * o'zi yozishga imkon beradi.
 */
export async function uploadEmployeePhoto(id: string, file: File): Promise<OperationResult> {
  const form = new FormData()
  form.append('file', file)
  const response = await api.post<unknown>(`/api/attendance/employees/${id}/photo`, form, {
    headers: { 'Content-Type': undefined },
  })
  return operationResultSchema.parse(response.data)
}

/**
 * Himoyalangan rasmni oladi (xodim fotosi yoki hodisa kadri).
 *
 * ⚠️ NEGA `<img src>` YARAMAYDI: bu endpointlar `Authorization: Bearer`
 * talab qiladi, brauzer esa `<img>` so'roviga sarlavha qo'sha olmaydi.
 * Tokenni URL'ga qo'yish (`?token=...`) muqobil bo'lardi, lekin u
 * tokenni brauzer tarixiga, proksi loglariga va `Referer` sarlavhasiga
 * chiqarardi. Shuning uchun rasm axios orqali `Blob` bo'lib olinadi va
 * `URL.createObjectURL` bilan ko'rsatiladi.
 */
export async function fetchImageBlob(url: string, signal?: AbortSignal): Promise<Blob> {
  const response = await api.get<Blob>(url, {
    responseType: 'blob',
    ...(signal ? { signal } : {}),
  })
  return response.data
}

/**
 * Xodim fotosining manzili.
 *
 * <h2>⚠️ `version` — BU BEZAK EMAS, NUQSONNING TUZATMASI (BUG-034)</h2>
 * Tashqi tester «PHOTONI UPDATE QILIB BO'LMAYABDI» deb yozgan: yangi
 * rasm yuklanadi, server «saqlandi» deydi, ekranda esa ESKISI qoladi.
 * Server tomoni bunda AYBSIZ — u rasmni haqiqatan almashtiradi
 * (`attendance.employee.photo_sha256` yangilanadi va sinxronlash
 * navbatga qo'yiladi). Nuqson butunlay mijozda edi va ikki qavatli:
 *
 * <ol>
 *   <li>manzil faqat `id` dan tuzilardi, ya'ni yuklashdan OLDIN ham,
 *       KEYIN ham AYNAN bir xil satr. `AuthedImage` ning effekti
 *       `[url, present]` ga bog'langan — ikkalasi ham o'zgarmagani
 *       uchun effekt QAYTA ISHLAMASDI va eski `objectURL` ekranda
 *       qolaverardi;</li>
 *   <li>server javobida `Cache-Control: max-age=3600, private`
 *       (`EmployeeResource`) turadi. Ya'ni effekt qayta ishlaganda ham
 *       brauzer bir soat davomida so'rovni tarmoqqa CHIQARMAY, o'z
 *       keshidan eski baytlarni berardi.</li>
 * </ol>
 *
 * <p>⚠️ Ikkala qavat bitta parametr bilan yopiladi: manzilga rasmning
 * `photo_sha256` i qo'shiladi. U MAZMUNDAN kelib chiqadi, ya'ni
 * <b>rasm o'zgarsa manzil o'zgaradi</b> (effekt qayta ishlaydi, kesh
 * chetlab o'tiladi), rasm o'zgarmasa esa manzil ham o'zgarmaydi —
 * kesh o'z ishini qilaveradi. Tasodifiy son (`Date.now()`) ham
 * ishlardi, lekin u keshni HAR SAFAR buzardi.
 *
 * <p>⚠️ Server bu parametrni O'QIMAYDI va o'qishi ham shart emas:
 * Spring tanilmagan so'rov parametrlarini e'tiborsiz qoldiradi.
 * U faqat brauzer va `useEffect` uchun — ikkalasi ham manzilni
 * satr sifatida solishtiradi.
 *
 * @param id      xodim identifikatori
 * @param version `photoSha256` — bo'lmasa parametr qo'shilmaydi
 */
export const employeePhotoUrl = (id: string, version?: string | null) =>
  `/api/attendance/employees/${id}/photo${version ? `?v=${encodeURIComponent(version)}` : ''}`

export const eventPictureUrl = (id: string) => `/api/attendance/events/${id}/picture`

/**
 * Tabel raqami tekshiruvi — bazadagi `employee_no_numeric` cheklovining
 * aynan o'zi (`^[0-9]{1,32}$`).
 *
 * ⚠️ NEGA MIJOZDA HAM: cheklov bazada bor, ya'ni server xato qiymatni
 * baribir rad etadi — lekin xabar `CONSTRAINT_23514` kabi tushunarsiz
 * matn bo'lib qaytardi. Bu yerdagi tekshiruv AYNAN nima noto'g'ri
 * ekanini aytadi, va eng muhimi — SABABINI: bu bizning injiqligimiz
 * emas, qurilma boshqasini qabul qilmaydi.
 */
const EMPLOYEE_NO = /^[0-9]{1,32}$/

export function isValidEmployeeNo(value: string): boolean {
  return EMPLOYEE_NO.test(value.trim())
}

// --- Hodisalar ---------------------------------------------------------------

/**
 * Hodisa natijasi — `event_result_valid` cheklovidagi TO'RT qiymat.
 *
 * ⚠️ `DENIED` HAM SAQLANADI va u ham ko'rsatiladi. "Yuz tanilmadi" —
 * davomat fakti: kimdir eshik oldida turgan. Faqat muvaffaqiyatlilarni
 * ko'rsatish "hech kim kelmagan" degan yolg'on xulosaga olib kelardi,
 * holbuki odam kelgan va o'ta olmagan — bu butunlay boshqa vaziyat va
 * u ko'pincha aynan tergov kerak bo'lganda qidiriladi.
 *
 * `DOOR` — eshikning o'z hodisasi (ochildi/yopildi), xodimsiz.
 * `OTHER` — tasniflanmagan kod. ⚠️ Backend noma'lum `minor` ni ATAYLAB
 * shu yerga qo'yadi, `GRANTED` ga emas (`DeviceEventRecord.classify`):
 * noma'lum kodni "o'tkazildi" deb hisoblash SOXTA DAVOMAT yasardi.
 */
export const EVENT_RESULTS = ['GRANTED', 'DENIED', 'DOOR', 'OTHER'] as const
export type EventResult = (typeof EVENT_RESULTS)[number]

const eventSchema = z.object({
  id: uuidSchema,
  deviceId: uuidSchema,
  /** Server JOIN bilan qo'shadi — `event` jadvalida bunday ustun yo'q */
  deviceName: z.string().nullish(),
  /**
   * ⚠️ `null` — ODATIY HOL, nosozlik emas: `minor=76` (yuz tanilmadi) va
   * eshik hodisalarida qurilma xodim raqamini umuman bermaydi.
   */
  employeeNo: z.string().nullish(),
  employeeId: uuidSchema.nullish(),
  /** Qurilma aytgan ism. Xodim keyin o'chirilsa ham yozuv o'qiladi. */
  displayName: z.string().nullish(),
  /** ⚠️ UTC (`event.event_time`) */
  eventTime: instantSchema,
  /**
   * ⚠️ QURILMA YOZGANI, XOM HOLDA: `2026-08-11T16:39:32+08:00`.
   * Bu ustunning butun ma'nosi shunda — qurilma zonasi noto'g'ri bo'lsa
   * (2026-08-11 da o'lchangan holat) farqni FAQAT shu ikkovini
   * (`eventTime` va shu) yonma-yon qo'yib ko'rish mumkin.
   */
  deviceTimeRaw: z.string().nullish(),
  major: z.number().nullish(),
  /** Usul ustunining asosiy manbai — `verifyMode.ts` ga qarang */
  minor: z.number().nullish(),
  /** `currentVerifyMode` xom holda. Qurilma bermasligi mumkin. */
  verifyMode: z.string().nullish(),
  result: z.enum(EVENT_RESULTS),
  /**
   * ⚠️ Hodisa YOZILGAN PAYTDAGI qurilma yo'nalishi, nusxa sifatida
   * muhrlangan (`attendance.event.direction`). Qurilmaning BUGUNGI
   * sozlamasi EMAS: terminal boshqa eshikka ko'chirilsa o'tmishdagi
   * yozuv o'zgarmasligi kerak.
   *
   * ⚠️ Bu yerda `.nullish()` — ro'yxatning O'ZI eski serverda ham
   * ochilishi kerak (`consecutiveFailures` bilan bir xil qoida:
   * panel bazadagi cheklovga emas, JAVOBGA ishonadi).
   */
  direction: z.enum(DEVICE_DIRECTIONS).nullish(),
  serialNo: z.number().nullish(),
  doorNo: z.number().nullish(),
  /** Kadr bormi. Yo'l EMAS — rasm alohida endpointda (`eventPictureUrl`). */
  hasPicture: z.boolean().nullish(),
  /** `PUSH` (webhook) yoki `PULL` (AcsEvent) */
  source: z.string().nullish(),
  receivedAt: instantSchema.nullish(),
})

export interface AttendanceEvent {
  id: string
  deviceId: string
  deviceName: string | null
  employeeNo: string | null
  employeeId: string | null
  displayName: string | null
  eventTime: string
  deviceTimeRaw: string | null
  major: number | null
  minor: number | null
  verifyMode: string | null
  result: EventResult
  /** `null` = server bu maydonni bermadi (eski versiya), `BOTH` = yo'nalish ma'lum emas */
  direction: DeviceDirection | null
  serialNo: number | null
  doorNo: number | null
  hasPicture: boolean
  source: string | null
  receivedAt: string | null
}

function toEvent(raw: z.infer<typeof eventSchema>): AttendanceEvent {
  return {
    id: raw.id,
    deviceId: raw.deviceId,
    deviceName: raw.deviceName ?? null,
    employeeNo: raw.employeeNo ?? null,
    employeeId: raw.employeeId ?? null,
    displayName: raw.displayName ?? null,
    eventTime: raw.eventTime,
    deviceTimeRaw: raw.deviceTimeRaw ?? null,
    major: raw.major ?? null,
    minor: raw.minor ?? null,
    verifyMode: raw.verifyMode ?? null,
    result: raw.result,
    direction: raw.direction ?? null,
    serialNo: raw.serialNo ?? null,
    doorNo: raw.doorNo ?? null,
    hasPicture: raw.hasPicture ?? false,
    source: raw.source ?? null,
    receivedAt: raw.receivedAt ?? null,
  }
}

const eventPageSchema = z.object({
  rows: z.array(eventSchema),
  total: z.number(),
  page: z.number(),
  size: z.number(),
})

export interface EventFilter {
  /** ISO-8601 UTC — panel tenant zonasidagi kun chegarasidan yasaydi */
  from: string
  to: string
  deviceId?: string | null
  employeeNo?: string | null
  result?: EventResult | null
}

/**
 * Hodisalar ro'yxati — filtr YOPIQ olinadi (`AuditPage` andozasi).
 *
 * ⚠️ SANA ORALIG'I MAJBURIY. `attendance.event` cheksiz o'sadi (har
 * o'tish bitta qator) va filtrsiz so'rov butun tarixni tortishga
 * urinardi — CLAUDE.md §6 dagi "har doim LIMIT va sana filtri" qoidasi
 * aynan shu jadval haqida.
 *
 * ⚠️ ERKIN QIDIRUV YO'Q: filtrlar STRUKTURAVIY (qurilma, xodim, natija),
 * shuning uchun `DataTable` bu yerda `searchable` EMAS — ishlamaydigan
 * qidiruv maydoni bo'lmaganidan yomonroq.
 */
export function fetchEventPage(filter: EventFilter) {
  return async (state: TableState, signal: AbortSignal): Promise<PageResult<AttendanceEvent>> => {
    const response = await api.get<unknown>('/api/attendance/events', {
      signal,
      params: {
        from: filter.from,
        to: filter.to,
        deviceId: filter.deviceId ?? undefined,
        employeeNo: filter.employeeNo ?? undefined,
        result: filter.result ?? undefined,
        page: state.page - 1,
        size: state.pageSize,
      },
    })
    const parsed = eventPageSchema.parse(response.data)
    return { items: parsed.rows.map(toEvent), total: parsed.total }
  }
}

// --- Hisobot -----------------------------------------------------------------
//
// ⚠️ HAMMA HISOBOT BIR XIL SHAKLDA: `rows` + yig'indilar + OGOHLANTIRISHLAR
// (`notes`, `truncated`, `multiZone`). Oxirgilari IXTIYORIY BEZAK EMAS va
// ular UI'da ko'rsatilishi SHART. Sabab: hisobot raqamlari ish haqi va
// intizom qarorlariga asos bo'ladi, ya'ni "bu raqam qanchalik ishonchli"
// degan savol raqamning O'ZI bilan bir xil darajada muhim. Ogohlantirishni
// tashlab yuborish jimgina "hammasi aniq" degan da'vo bo'lardi.

/**
 * Kun holati — SERVERDAN keladi (`DayStatus` enum'i).
 *
 *   `COMPLETE`   — kelish ham, ketish ham bor. Faqat shu holatda ishlagan
 *                  vaqt MA'LUM.
 *   `INCOMPLETE` — biri bor, ikkinchisi yo'q. ⚠️ Ishlagan vaqt NOMA'LUM
 *                  va uni "0" deb ko'rsatish YOLG'ON bo'lardi: odam kun
 *                  bo'yi ishlagan bo'lishi mumkin, shunchaki chiqishda
 *                  terminalga yaqinlashmagan.
 *   `ABSENT`     — birorta yozuv yo'q.
 *
 * ⚠️ Bu ro'yxat ILGARI PANELDA HISOBLANARDI (kelish/ketish bor-yo'qligidan)
 * — o'shanda server enum'ining nomi noma'lum edi va `PRESENT` bo'lib
 * chiqishi mumkin deb qo'rqilgandi. Endi kontrakt aniq: uchtasi ham AYNAN
 * shu nomda. Shuning uchun qiymat serverdan olinadi va `z.enum` QOTIRILGAN
 * — server to'rtinchi holat qo'shsa, u jimgina "noma'lum" bo'lib emas,
 * zod xatosi bilan darhol ko'rinsin.
 *
 * ⚠️ `statusLabel` (server tayyorlagan matn) ATAYLAB O'QILMAYDI. Panel uch
 * tilda ishlaydi, server esa bitta til tanlaydi — uni ko'rsatish tanlangan
 * tildan qat'i nazar bir xil matn berardi. Kod (`status`) tarjima
 * qilinadi, matn esa tashlanadi.
 */
export const DAY_STATUSES = ['COMPLETE', 'INCOMPLETE', 'ABSENT'] as const
export type DayStatus = (typeof DAY_STATUSES)[number]

/**
 * Kelish/ketish QAYERDAN chiqdi — O'LCHOVMI yoki XULOSAMI.
 *
 * ⚠️⚠️ BU USTUN BEZAK EMAS. Bir xil ko'rinishdagi "09:00 — 18:00"
 * ikki butunlay boshqa yo'l bilan chiqishi mumkin:
 *
 *   `DIRECTION` — terminal kirish (yoki chiqish) nuqtasi deb
 *                 belgilangan. Bu O'LCHOV: "kirdi, chiqmadi" FAKT.
 *   `ORDER`     — yo'nalish ma'lum emas va kunning birinchi yozuvi
 *                 "kelish", oxirgisi "ketish" deb OLINDI. Bu XULOSA
 *                 va u xato bo'lishi mumkin (tushlikka chiqib
 *                 qaytgan odamda oxirgi yozuv aslida qaytish).
 *   `MIXED`     — bir tomoni o'lchov, ikkinchisi xulosa.
 *
 * Ikkalasini bir xil ko'rsatish hisobotni haqiqiydan ishonchliroq
 * qilib chizardi — bu modul butun bo'yicha aynan shundan qochadi.
 */
export const DIRECTION_SOURCES = ['DIRECTION', 'ORDER', 'MIXED'] as const
export type DirectionSource = (typeof DIRECTION_SOURCES)[number]

/**
 * Bitta ogohlantirish — KOD, parametrlar va serverning zaxira matni.
 *
 * ⚠️ NEGA OBYEKT, satr EMAS (tashqi tester, C2). Ilgari server tayyor
 * o'zbekcha jumla yuborardi va panel uni ATAYLAB xom holda chizardi —
 * natijada inglizcha hisobotning ishonchlilik bloki butunlay o'zbekcha
 * bo'lardi. Endi tarjima panelda: kalit `code` dan yasaladi
 * (`attendance.report.notice.<CODE>`), `params` esa `{{count}}` /
 * `{{zones}}` ni to'ldiradi.
 *
 * ⚠️ `text` — ZAXIRA va u tashlanmaydi: server yangi kod qo'shsa va
 * panel uni hali bilmasa, o'quvchi bo'sh joy emas, serverning
 * jumlasini ko'radi. "Noma'lum kodni ko'rsatma" degan variant
 * ogohlantirishni JIMGINA yo'qotardi.
 */
const reportNoteSchema = z.object({
  code: z.string(),
  params: z.record(z.string(), z.unknown()).nullish(),
  text: z.string(),
})

export type ReportNote = z.infer<typeof reportNoteSchema>

/** Uch hisobotda ham takrorlanadigan ogohlantirishlar to'plami */
const noticeShape = {
  notes: z.array(reportNoteSchema).nullish(),
  /**
   * ⚠️ Natija KESILGAN. Bu eng xavfli bayroq: kesilgan ro'yxat to'liq
   * ro'yxatdan farq qilmaydi — u shunchaki qisqaroq. Ko'rsatilmasa
   * operator "bu xodim kelmagan" degan xulosaga kelardi, holbuki qator
   * chegaradan tashqarida qolgan.
   */
  truncated: z.boolean().nullish(),
} as const

/** Bir necha zonadan yig'ilgan hisobot — kun chegarasi bir xil emas */
const zoneShape = {
  zones: z.array(z.string()).nullish(),
  /**
   * ⚠️ Bir nechta vaqt zonasi aralashgan. Kun chegarasi zonaga bog'liq,
   * ya'ni bunday hisobotda "bugun" tushunchasi bitta emas. Bu raqamni
   * noto'g'ri qilmaydi, lekin uni SHARTLI qiladi — va operator buni
   * bilishi kerak.
   */
  multiZone: z.boolean().nullish(),
} as const

export interface ReportNotices {
  notes: readonly ReportNote[]
  truncated: boolean
  zones: readonly string[]
  multiZone: boolean
}

function toNotices(raw: {
  notes?: readonly ReportNote[] | null
  truncated?: boolean | null
  zones?: readonly string[] | null
  multiZone?: boolean | null
}): ReportNotices {
  return {
    notes: raw.notes ?? [],
    truncated: raw.truncated ?? false,
    zones: raw.zones ?? [],
    multiZone: raw.multiZone ?? false,
  }
}

// --- Kunlik hisobot ----------------------------------------------------------

const dailyRowSchema = z.object({
  employeeNo: z.string(),
  employeeId: uuidSchema.nullish(),
  displayName: z.string().nullish(),
  /**
   * ⚠️ Qurilma yuborgan tabel raqami reyestrda TOPILDIMI. `false` —
   * o'chirilgan yoki tizimni chetlab o'tib qurilmaga qo'shilgan odam,
   * va aynan shunday qator tekshiruvda birinchi qidiriladi.
   */
  inRegistry: z.boolean().nullish(),
  status: z.enum(DAY_STATUSES),
  /**
   * ⚠️ Kelish/ketish o'lchandimi yoki taxmin qilindimi
   * (`DIRECTION_SOURCES`). `.nullish()` — maydonsiz eski javobda
   * panel `ORDER` deb o'qiydi, ya'ni EHTIYOTKOR tomonga xato qiladi:
   * "xulosa" deb ko'rsatish "o'lchov" deb ko'rsatishdan xavfsizroq.
   */
  directionSource: z.enum(DIRECTION_SOURCES).nullish(),
  /**
   * ⚠️ JUFTLANMAGAN: kirish bor, chiqish yo'q (yoki teskarisi). Bu
   * NOSOZLIK EMAS — odam chiqishda terminaldan o'tmasligi odatiy hol.
   *
   * ⚠️ `status === 'INCOMPLETE'` bilan TENG EMAS: chiqish kirishdan
   * oldin bo'lgan kun ham `INCOMPLETE`, lekin u yerda IKKALA yozuv
   * ham bor. Shuning uchun alohida maydon, hisoblab olinadigan
   * qiymat emas.
   */
  unpaired: z.boolean().nullish(),
  /**
   * ⚠️ `firstInAt`, `firstIn` EMAS. Bu maydon avval `firstIn` deb taxmin
   * qilingan edi va xato JIMGINA o'tib ketardi: `.nullish()` tufayli zod
   * shikoyat qilmasdi, vaqtlar bo'sh chiqardi, holat esa har qatorda
   * "KELMAGAN" bo'lib ko'rinardi — hisobot ishlayotgandek turib butunlay
   * yolg'on gapirardi.
   */
  firstInAt: instantSchema.nullish(),
  /** Server hisobot zonasida tayyorlagan matn — tooltip'da isbot sifatida */
  firstInLocal: z.string().nullish(),
  /** Qaysi terminal yozgan */
  firstInDevice: z.string().nullish(),
  lastOutAt: instantSchema.nullish(),
  lastOutLocal: z.string().nullish(),
  lastOutDevice: z.string().nullish(),
  /**
   * ⚠️ Server tugallanmagan kunda buni `null` qiladi — "0 soat yozilmasin"
   * qoidasi BACKENDDA ham bajarilgan. Paneldagi qorovul (faqat `COMPLETE`
   * da ko'rsatish) shunga qaramay OLIB TASHLANMAYDI: ikki qatlam himoya
   * bir-birini takrorlaydi, lekin bu yerda takror arzon va xato qimmat.
   */
  workedMinutes: z.number().nullish(),
  /** ⚠️ `workedHours` (server matni) O'QILMAYDI — `statusLabel` bilan bir xil sabab */
  scanCount: z.number().nullish(),
  /** Xom o'tishlar soni — `scanCount` dedublikatsiyadan KEYIN */
  rawScanCount: z.number().nullish(),
  deniedCount: z.number().nullish(),
  zones: z.array(z.string()).nullish(),
  /**
   * ⚠️ Tungi smena GUMONI. Kun chegarasi yarim tunda o'tadi, ya'ni tunda
   * ishlagan odamning bitta smenasi IKKI kunga bo'linadi va ikkalasi ham
   * "tugallanmagan" bo'lib ko'rinadi. Server buni gumon qiladi va aytadi;
   * panel esa uni yashirmasligi kerak, aks holda operator mavjud bo'lmagan
   * intizom buzilishini "topardi".
   */
  nightShiftSuspected: z.boolean().nullish(),
  note: z.string().nullish(),
})

const dailyReportSchema = z.object({
  date: z.string().nullish(),
  // ⚠️ `rows` — bo'lim sarlavhasidagi izohga qarang (hisobotda ham,
  // sahifada ham nom bitta; farq `page`/`total` da)
  rows: z.array(dailyRowSchema),
  presentCount: z.number().nullish(),
  completeCount: z.number().nullish(),
  incompleteCount: z.number().nullish(),
  absentCount: z.number().nullish(),
  /** Juftlanmagan kunlar soni — `incompleteCount` bilan teng EMAS (qator sxemasidagi izoh) */
  unpairedCount: z.number().nullish(),
  /**
   * ⚠️ HISOBOTNING ENG MUHIM OGOHLANTIRISHI. Qurilma "yuz tanilmadi"
   * hodisasida xodim raqamini UMUMAN yubormaydi (`minor=76`), ya'ni bu
   * urinishlarni hech kimga bog'lab bo'lmaydi. Natijada `KELMAGAN`
   * qatorlari ishonchsiz bo'lishi mumkin: odam kelgan, terminal uni
   * tanimagan, hisobotda esa u umuman kelmagandek ko'rinadi.
   *
   * Shuning uchun bu son UI'da KO'RSATILADI. Uni tashlab yuborish
   * hisobotni haqiqiydan ko'ra ishonchliroq qilib ko'rsatardi — aynan
   * biz qochayotgan narsa.
   */
  unidentifiedDeniedCount: z.number().nullish(),
  /** Tanildi, lekin reyestrdagi xodimga bog'lanmadi */
  unattributedGrantedCount: z.number().nullish(),
  ...zoneShape,
  ...noticeShape,
})

export interface DailyReportRow {
  employeeNo: string
  employeeId: string | null
  displayName: string | null
  inRegistry: boolean
  status: DayStatus
  /** O'LCHOV (`DIRECTION`) yoki XULOSA (`ORDER`) — `DIRECTION_SOURCES` izohi */
  directionSource: DirectionSource
  /** Kirish bor, chiqish yo'q (yoki teskarisi). ⚠️ Nosozlik EMAS. */
  unpaired: boolean
  firstInAt: string | null
  firstInLocal: string | null
  firstInDevice: string | null
  lastOutAt: string | null
  lastOutLocal: string | null
  lastOutDevice: string | null
  /** ⚠️ `null` = NOMA'LUM. `COMPLETE` bo'lmagan kunda HAR DOIM `null`. */
  workedMinutes: number | null
  scanCount: number | null
  deniedCount: number | null
  zones: readonly string[]
  nightShiftSuspected: boolean
  note: string | null
}

export interface DailyReport {
  date: string | null
  rows: readonly DailyReportRow[]
  presentCount: number | null
  completeCount: number | null
  incompleteCount: number | null
  absentCount: number | null
  unpairedCount: number | null
  unidentifiedDeniedCount: number | null
  unattributedGrantedCount: number | null
  notices: ReportNotices
}

/**
 * Kunlik hisobot.
 *
 * ⚠️ ISHLAGAN VAQT FAQAT `COMPLETE` KUNDA QAYTADI — server allaqachon
 * shunday qiladi, lekin panel ham shuni qayta ta'minlaydi. Ikki qatlam
 * bir-birini takrorlaydi va bu ATAYLAB: bu raqam bo'yicha ish haqi
 * hisoblanadi, ya'ni bitta qatlamning kelajakdagi o'zgarishi jimgina
 * o'ylab topilgan raqamni ekranga chiqarmasligi kerak.
 */
export async function fetchDailyReport(
  date: string,
  signal?: AbortSignal,
): Promise<DailyReport> {
  const response = await api.get<unknown>('/api/attendance/report', {
    params: { date },
    ...(signal ? { signal } : {}),
  })
  const raw = dailyReportSchema.parse(response.data)
  return {
    date: raw.date ?? null,
    rows: raw.rows.map((row) => ({
      employeeNo: row.employeeNo,
      employeeId: row.employeeId ?? null,
      displayName: row.displayName ?? null,
      // `undefined` → `true`: maydon kelmasa "reyestrda yo'q" degan
      // OGOHLANTIRISHNI yolg'ondan chizishdan ko'ra, uni umuman
      // ko'rsatmagan yaxshi.
      inRegistry: row.inRegistry ?? true,
      status: row.status,
      // ⚠️ Maydonsiz javobda `ORDER` — EHTIYOTKOR tomon: xulosani
      // o'lchov deb ko'rsatishdan ko'ra teskarisi xavfsizroq.
      directionSource: row.directionSource ?? 'ORDER',
      unpaired: row.unpaired ?? false,
      firstInAt: row.firstInAt ?? null,
      firstInLocal: row.firstInLocal ?? null,
      firstInDevice: row.firstInDevice ?? null,
      lastOutAt: row.lastOutAt ?? null,
      lastOutLocal: row.lastOutLocal ?? null,
      lastOutDevice: row.lastOutDevice ?? null,
      workedMinutes: row.status === 'COMPLETE' ? (row.workedMinutes ?? null) : null,
      scanCount: row.scanCount ?? null,
      deniedCount: row.deniedCount ?? null,
      zones: row.zones ?? [],
      nightShiftSuspected: row.nightShiftSuspected ?? false,
      note: row.note ?? null,
    })),
    presentCount: raw.presentCount ?? null,
    completeCount: raw.completeCount ?? null,
    incompleteCount: raw.incompleteCount ?? null,
    absentCount: raw.absentCount ?? null,
    unpairedCount: raw.unpairedCount ?? null,
    unidentifiedDeniedCount: raw.unidentifiedDeniedCount ?? null,
    unattributedGrantedCount: raw.unattributedGrantedCount ?? null,
    notices: toNotices(raw),
  }
}

// --- Oylik hisobot -----------------------------------------------------------

const monthlyRowSchema = z.object({
  /** `YYYY-MM-DD` — oyning bitta KUNI */
  date: z.string(),
  /*
    ⛔ `null` — UMUMIY REJIMDA HAR QATORDA.

    Xodim tanlanmaganda qator BUTUN TASHKILOTNING kuni bo'ladi va
    «kelgan/kelmagan» degan yagona holat MAVJUD EMAS. Server buni
    ochiq aytadi: `AttendanceReportServiceImpl.monthlyRow` da
    `row == null` shoxi `new MonthlyRow(day, null, ...)` qaytaradi, va
    `non_null` ostida maydon javobga umuman yozilmaydi.

    ⛔ Ilgari bu yerda `z.enum(DAY_STATUSES)` MAJBURIY edi — ya'ni
    xodim tanlanmagan holatda HAMMA qator rad etilardi va oylik
    hisobot sahifasi umuman chizilmasdi. Pastdagi `employeeCount`
    izohi o'sha rejim borligini allaqachon aytib turgan edi.
  */
  status: z.enum(DAY_STATUSES).nullish(),
  firstInAt: instantSchema.nullish(),
  firstInLocal: z.string().nullish(),
  lastOutAt: instantSchema.nullish(),
  lastOutLocal: z.string().nullish(),
  workedMinutes: z.number().nullish(),
  /**
   * ⚠️ FAQAT UMUMIY REJIMDA ma'noli: xodim tanlanmaganda qator BUTUN
   * TASHKILOTNING shu kuni bo'ladi va bu maydon o'sha kuni nechta xodim
   * ko'ringanini aytadi. Xodim tanlanganda u ma'nosiz (har doim 1 yoki 0)
   * va ustun umuman chizilmaydi.
   */
  employeeCount: z.number().nullish(),
  completeCount: z.number().nullish(),
  incompleteCount: z.number().nullish(),
  absentCount: z.number().nullish(),
  deniedCount: z.number().nullish(),
  nightShiftSuspected: z.boolean().nullish(),
  note: z.string().nullish(),
})

const monthlyTotalsSchema = z.object({
  workedMinutes: z.number().nullish(),
  completeDays: z.number().nullish(),
  incompleteDays: z.number().nullish(),
  absentDays: z.number().nullish(),
  deniedCount: z.number().nullish(),
  nightShiftDays: z.number().nullish(),
})

const monthlyReportSchema = z.object({
  month: z.string().nullish(),
  from: z.string().nullish(),
  to: z.string().nullish(),
  employeeId: uuidSchema.nullish(),
  employeeNo: z.string().nullish(),
  displayName: z.string().nullish(),
  rows: z.array(monthlyRowSchema),
  totals: monthlyTotalsSchema.nullish(),
  ...zoneShape,
  ...noticeShape,
})

export interface MonthlyReportRow {
  date: string
  /** ⛔ `null` — UMUMIY rejim: bir kunning yagona holati YO'Q (sxema izohi) */
  status: DayStatus | null
  firstInAt: string | null
  firstInLocal: string | null
  lastOutAt: string | null
  lastOutLocal: string | null
  workedMinutes: number | null
  employeeCount: number | null
  completeCount: number | null
  incompleteCount: number | null
  absentCount: number | null
  deniedCount: number | null
  nightShiftSuspected: boolean
  note: string | null
}

export interface MonthlyTotals {
  workedMinutes: number | null
  completeDays: number | null
  incompleteDays: number | null
  absentDays: number | null
  deniedCount: number | null
  nightShiftDays: number | null
}

export interface MonthlyReport {
  month: string | null
  /** `null` = UMUMIY rejim (butun tashkilot bo'yicha kunlik yig'indi) */
  employeeId: string | null
  employeeNo: string | null
  displayName: string | null
  rows: readonly MonthlyReportRow[]
  totals: MonthlyTotals | null
  notices: ReportNotices
}

/**
 * Oylik hisobot — IKKI REJIMDA ishlaydi va ular BOSHQA savolga javob beradi.
 *
 * ⚠️ BU MAYDON AVVAL BUTUNLAY NOTO'G'RI TUSHUNILGAN EDI. Panel uni
 * "xodim × oy YAKUNI" (har xodim uchun bitta qator: necha kun keldi,
 * necha soat ishladi) deb olgan edi. Aslida qatorlar — KUNLAR:
 *
 *   `employeeId` BERILGAN   → o'sha xodimning oyi, kun-baday.
 *                             "Alisher shu oyda qaysi kunlari kelmagan?"
 *   `employeeId` BERILMAGAN → butun tashkilotning oyi, kun-baday
 *                             (`employeeCount` shuning uchun bor).
 *                             "Qaysi kunlari kelganlar kam bo'lgan?"
 *
 * Ikkalasi ham kerak va ularni bittasiga siqib bo'lmaydi — shuning uchun
 * UI'da xodim tanlagichi bor va u BO'SH qoldirilishi mumkin.
 */
export async function fetchMonthlyReport(
  month: string,
  employeeId: string | null,
  signal?: AbortSignal,
): Promise<MonthlyReport> {
  const response = await api.get<unknown>('/api/attendance/report/monthly', {
    // Bo'sh tanlov UMUMAN yuborilmaydi (`undefined`) — bo'sh satr
    // sifatida emas: server uchun "berilmagan" va "bo'sh" boshqa narsa.
    params: { month, employeeId: employeeId ?? undefined },
    ...(signal ? { signal } : {}),
  })
  return parseMonthlyReport(response.data)
}

/**
 * Javobni panel shakliga aylantiradi — CHAQIRUV JOYIDAN AJRATILGAN.
 *
 * Sabab `null-contract.mjs` 4-bo'limidagi bilan bir xil: naqsh
 * skaneri faqat matnni ko'radi va sxema "to'g'ri" bo'lib turib jonli
 * javobda yiqilishi mumkin. Eksport qilingani uchun qorovul unga
 * UMUMIY rejimning ayni javob shaklini bera oladi
 * (`tests/null-drop-shape.mjs`) — tarmoqsiz.
 */
export function parseMonthlyReport(payload: unknown): MonthlyReport {
  const raw = monthlyReportSchema.parse(payload)
  return {
    month: raw.month ?? null,
    employeeId: raw.employeeId ?? null,
    employeeNo: raw.employeeNo ?? null,
    displayName: raw.displayName ?? null,
    rows: raw.rows.map((row) => ({
      date: row.date,
      status: row.status ?? null,
      firstInAt: row.firstInAt ?? null,
      firstInLocal: row.firstInLocal ?? null,
      lastOutAt: row.lastOutAt ?? null,
      lastOutLocal: row.lastOutLocal ?? null,
      // Kunlik hisobotdagi bilan AYNAN bir xil qorovul va bir xil sabab.
      workedMinutes: row.status === 'COMPLETE' ? (row.workedMinutes ?? null) : null,
      employeeCount: row.employeeCount ?? null,
      completeCount: row.completeCount ?? null,
      incompleteCount: row.incompleteCount ?? null,
      absentCount: row.absentCount ?? null,
      deniedCount: row.deniedCount ?? null,
      nightShiftSuspected: row.nightShiftSuspected ?? false,
      note: row.note ?? null,
    })),
    totals: raw.totals
      ? {
          // ⚠️ Yakundagi `workedMinutes` ga qorovul QO'YILMAYDI: u
          // allaqachon FAQAT to'liq kunlar yig'indisi (backend shunday
          // hisoblaydi) va uni "faqat COMPLETE da ko'rsat" deb filtrlash
          // mumkin emas — yakunning o'zida holat tushunchasi yo'q.
          workedMinutes: raw.totals.workedMinutes ?? null,
          completeDays: raw.totals.completeDays ?? null,
          incompleteDays: raw.totals.incompleteDays ?? null,
          absentDays: raw.totals.absentDays ?? null,
          deniedCount: raw.totals.deniedCount ?? null,
          nightShiftDays: raw.totals.nightShiftDays ?? null,
        }
      : null,
    notices: toNotices(raw),
  }
}

// --- Oxirgi ro'yxatdan o'tish ------------------------------------------------

const lastSeenRowSchema = z.object({
  employeeNo: z.string(),
  employeeId: uuidSchema.nullish(),
  displayName: z.string().nullish(),
  inRegistry: z.boolean().nullish(),
  lastSeenAt: instantSchema.nullish(),
  lastSeenLocal: z.string().nullish(),
  zone: z.string().nullish(),
  deviceName: z.string().nullish(),
  /** Qurilma usulining KODI (server tasnifi) */
  method: z.string().nullish(),
  /**
   * ⚠️ SERVER TAYYORLAGAN MATN va u YERDA `statusLabel` DAN FARQLI
   * O'LAROQ ISHLATILADI. Sabab: usul tarjimasi (`verifyMode.ts`) xom
   * `minor` kodidan quriladi, bu endpoint esa `minor` ni umuman
   * bermaydi — faqat tasniflangan `method`/`methodLabel` ni beradi.
   * Ikkinchi, mustaqil lug'at yasash ikki joyda ikki xil nom berish
   * xavfini tug'dirardi ("Yuz" va "Yuz tanish" bir xil narsa uchun).
   * Shuning uchun qoida: SERVER BERGAN JOYDA SERVERNIKI, bermagan
   * joyda (hodisalar jurnali) — o'zimizniki.
   */
  methodLabel: z.string().nullish(),
  verifyMode: z.string().nullish(),
  daysAgo: z.number().nullish(),
})

const lastSeenReportSchema = z.object({
  withinDays: z.number().nullish(),
  since: instantSchema.nullish(),
  rows: z.array(lastSeenRowSchema),
  /**
   * ⚠️ HECH QACHON ko'rinmagan xodimlar soni. Ular ro'yxatda YO'Q
   * (ko'rsatadigan vaqt yo'q), ya'ni bu son bo'lmasa ular butunlay
   * ko'rinmas bo'lardi — holbuki "hech qachon kelmagan xodim" aynan
   * shu sahifada qidiriladigan holat.
   */
  neverSeenCount: z.number().nullish(),
  ...noticeShape,
})

export interface LastSeenRow {
  employeeNo: string
  employeeId: string | null
  displayName: string | null
  inRegistry: boolean
  lastSeenAt: string | null
  zone: string | null
  deviceName: string | null
  /** Server tayyorlagan matn — o'zimizniki bilan TAKRORLANMAYDI */
  methodLabel: string | null
  daysAgo: number | null
}

export interface LastSeenReport {
  withinDays: number | null
  rows: readonly LastSeenRow[]
  neverSeenCount: number | null
  notices: ReportNotices
}

export async function fetchLastSeen(signal?: AbortSignal): Promise<LastSeenReport> {
  const response = await api.get<unknown>('/api/attendance/report/last-seen', {
    ...(signal ? { signal } : {}),
  })
  const raw = lastSeenReportSchema.parse(response.data)
  return {
    withinDays: raw.withinDays ?? null,
    rows: raw.rows.map((row) => ({
      employeeNo: row.employeeNo,
      employeeId: row.employeeId ?? null,
      displayName: row.displayName ?? null,
      inRegistry: row.inRegistry ?? true,
      lastSeenAt: row.lastSeenAt ?? null,
      zone: row.zone ?? null,
      deviceName: row.deviceName ?? null,
      methodLabel: row.methodLabel ?? row.method ?? null,
      daysAgo: row.daysAgo ?? null,
    })),
    neverSeenCount: raw.neverSeenCount ?? null,
    notices: toNotices(raw),
  }
}

// --- Hozir ichkarida ---------------------------------------------------------

const presentRowSchema = z.object({
  employeeNo: z.string(),
  employeeId: uuidSchema.nullish(),
  displayName: z.string().nullish(),
  inRegistry: z.boolean().nullish(),
  /** Qachondan beri ichkarida deb HISOBLANAYAPTI */
  sinceAt: instantSchema.nullish(),
  sinceLocal: z.string().nullish(),
  zone: z.string().nullish(),
  deviceName: z.string().nullish(),
  scanCount: z.number().nullish(),
  minutesInside: z.number().nullish(),
  /**
   * ⚠️ Xulosa QAYERDAN chiqdi. `DIRECTION` — oxirgi skanerlash KIRISH
   * terminalida bo'lgan (o'lchov); `ORDER` — yo'nalish ma'lum emas va
   * toq/juft sanoq ishlatilgan (taxmin).
   *
   * ⚠️ Bitta ro'yxatda ikkalasi ARALASH bo'lishi odatiy, shuning
   * uchun manba har QATORDA. Bo'lmasa operator butun ro'yxatni bir xil
   * ishonchli deb o'qirdi.
   */
  source: z.enum(DIRECTION_SOURCES).nullish(),
})

const presentReportSchema = z.object({
  asOf: instantSchema.nullish(),
  /**
   * Qancha soatlik oyna ichida qaralgan. ⚠️ Bu ham xulosaning
   * SHARTLILIGINI ko'rsatadi: oyna tashqarisidagi odam ro'yxatga
   * tushmaydi, garchi u haqiqatan binoda bo'lsa ham.
   */
  windowHours: z.number().nullish(),
  rows: z.array(presentRowSchema),
  ...noticeShape,
})

export interface PresentRow {
  employeeNo: string
  employeeId: string | null
  displayName: string | null
  inRegistry: boolean
  sinceAt: string | null
  zone: string | null
  deviceName: string | null
  scanCount: number | null
  minutesInside: number | null
  /** O'LCHOV (`DIRECTION`) yoki TAXMIN (`ORDER`) */
  source: DirectionSource
}

export interface PresentReport {
  asOf: string | null
  windowHours: number | null
  rows: readonly PresentRow[]
  notices: ReportNotices
}

/**
 * Hozir ichkaridagilar.
 *
 * ⚠️⚠️ ISHONCHLILIK QATOR BO'YICHA HAR XIL — `row.source` ni o'qing.
 *
 * Ilgari butun ro'yxat bir xil edi: terminal yo'nalishni aytmaydi,
 * ya'ni xulosa faqat parity (yozuvlar soni juft-toqligi) bo'yicha
 * chiqarilardi. Qurilmaga yo'nalish qo'shilgach ikki xil qator paydo
 * bo'ldi:
 *
 *   `source === 'DIRECTION'` — oxirgi skanerlash KIRISH terminalida
 *                              bo'lgan. Bu O'LCHOV.
 *   `source === 'ORDER'`     — yo'nalish belgilanmagan, toq/juft
 *                              sanoq ishlatilgan. Bu TAXMIN.
 *
 * ⚠️ Ikkinchisida chiqishda terminalga yaqinlashmagan odam kechgacha
 * "ichkarida" bo'lib turadi.
 *
 * ⚠️ Birinchisi ham "binoda BOR" degan KAFOLAT emas: odam chiqishda
 * terminaldan o'tmagan bo'lishi mumkin. Ya'ni bu ro'yxatni evakuatsiya
 * ro'yxati sifatida ishlatib BO'LMAYDI — eng ehtimolli noto'g'ri
 * qo'llanish aynan shu, va yo'nalish qo'shilgani uni o'zgartirmaydi.
 * Server buni `notes` da har javobda o'zi ham yozadi.
 */
export async function fetchPresent(signal?: AbortSignal): Promise<PresentReport> {
  const response = await api.get<unknown>('/api/attendance/report/present', {
    ...(signal ? { signal } : {}),
  })
  const raw = presentReportSchema.parse(response.data)
  return {
    asOf: raw.asOf ?? null,
    windowHours: raw.windowHours ?? null,
    rows: raw.rows.map((row) => ({
      employeeNo: row.employeeNo,
      employeeId: row.employeeId ?? null,
      displayName: row.displayName ?? null,
      inRegistry: row.inRegistry ?? true,
      sinceAt: row.sinceAt ?? null,
      zone: row.zone ?? null,
      deviceName: row.deviceName ?? null,
      scanCount: row.scanCount ?? null,
      minutesInside: row.minutesInside ?? null,
      // ⚠️ Maydonsiz javobda `ORDER` — kunlik hisobotdagi bilan bir
      // xil ehtiyotkor tomon.
      source: row.source ?? 'ORDER',
    })),
    notices: toNotices(raw),
  }
}

// --- Eksport -----------------------------------------------------------------

export interface AttendanceExportParams {
  /** `YYYY-MM-DD` — kunlik hisobot uchun */
  date?: string
  /** `YYYY-MM` — oylik hisobot uchun. `date` bilan BIRGA berilmaydi. */
  month?: string
  employeeId?: string | null
  deviceId?: string | null
}

/**
 * Hisobotni fayl sifatida yuklab oladi.
 *
 * ⚠️ EKSPORT SERVERDA, brauzerda EMAS — `reportsApi.downloadReportExport`
 * bilan bir xil qaror. Panel faqat EKRANDAGI qatorlarni yoza olardi;
 * server esa butun natijani beradi va filtrlarni o'zi qo'llaydi.
 *
 * ⚠️ `format=xlsx` SERVER TOMONIDAN RAD ETILADI (HTTP 400) va bu
 * ATAYLAB: CSV faylni `.xlsx` nomi bilan berish yolg'on bo'lardi —
 * Excel uni ochadi, lekin bu haqiqiy `.xlsx` emas va boshqa dastur uni
 * o'qiy olmasdi. Shuning uchun panel `xlsx` ni SO'RAMAYDI ham va tugma
 * ochiq "Excel (CSV)" deb ataladi: fayl CSV, Excel uni to'g'ridan-to'g'ri
 * ochadi (BOM tufayli harflar ham buzilmaydi).
 */
export async function downloadAttendanceExport(params: AttendanceExportParams): Promise<void> {
  const response = await api.get<Blob>('/api/attendance/report/export', {
    responseType: 'blob',
    params: {
      date: params.date,
      month: params.month,
      employeeId: params.employeeId ?? undefined,
      deviceId: params.deviceId ?? undefined,
      format: 'csv',
    },
  })

  // Fayl nomi `Content-Disposition` dan — davr va tur serverda bir marta
  // hal qilinadi, ya'ni panel va boshqa mijozlar bir xil nom oladi.
  // Sarlavhani proksi kesib tashlashi mumkin, shuning uchun zaxira nom.
  const disposition = String(response.headers['content-disposition'] ?? '')
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition)
  const fallback = `davomat-${params.date ?? params.month ?? 'export'}.csv`
  const fromHeader = match?.[1]
  downloadBlob(response.data, fromHeader === undefined ? fallback : decodeURIComponent(fromHeader))
}

// --- Filtr uchun qisqa ro'yxatlar --------------------------------------------

export interface Option {
  value: string
  label: string
}

/**
 * Qurilma tanlagichi uchun ro'yxat.
 *
 * ⚠️ `size: 200` — filtr TANLAGICHI, sahifalangan ro'yxat emas.
 * Sahifalash bu yerda ma'nosiz bo'lardi: operator ochilgan ro'yxatda
 * qurilmasini topa olmasa, uning uchun bu "qurilma yo'q" degani.
 * Amalda bitta tashkilotda terminallar o'nlab bo'ladi, 200 esa
 * yetarlicha keng zaxira.
 */
export async function fetchDeviceOptions(): Promise<readonly Option[]> {
  const response = await api.get<unknown>('/api/attendance/devices', {
    params: { page: 0, size: 200 },
  })
  const parsed = devicePageSchema.parse(response.data)
  return parsed.rows.map((d) => ({ value: d.id, label: `${d.name} (${d.deviceId})` }))
}

/**
 * Xodim tanlagichi — IKKALA kalit ham qaytadi.
 *
 * ⚠️ `id` VA `employeeNo` NING IKKALASI HAM KERAK, chunki ikki filtr
 * BOSHQA-BOSHQA kalit bilan ishlaydi va bu tasodif emas:
 *
 *   Hodisalar (`/events?employeeNo=`) — MATN bo'yicha. `event.employee_no`
 *   ustuni FK'siz matn: qurilma reyestrda yo'q odamni xabar qilganda ham
 *   yozuv qoladi. `employeeId` bo'yicha filtrlash aynan o'sha — eng qiziq,
 *   tekshiruvda birinchi qidiriladigan — yozuvlarni ko'rinmas qilardi.
 *
 *   Oylik hisobot (`/report/monthly?employeeId=`) — UUID bo'yicha. U
 *   reyestrdagi xodimning oyini quradi, ya'ni reyestrda yo'q odam uchun
 *   savolning o'zi ma'nosiz.
 *
 * Bitta `value` maydoni bilan cheklanish chaqiruvchini "bu ro'yxatda
 * qaysi kalit turibdi?" deb taxmin qilishga majbur qilardi — va noto'g'ri
 * taxmin filtrni JIMGINA bo'sh natija beradigan qilardi.
 */
export interface EmployeeOption {
  id: string
  employeeNo: string
  label: string
}

export async function fetchEmployeeOptions(): Promise<readonly EmployeeOption[]> {
  const response = await api.get<unknown>('/api/attendance/employees', {
    params: { page: 0, size: 200 },
  })
  const parsed = employeePageSchema.parse(response.data)
  return parsed.rows.map((e) => ({
    id: e.id,
    employeeNo: e.employeeNo,
    label: `${e.fullName} (${e.employeeNo})`,
  }))
}
